import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Card,
  Form,
  Modal,
  ListGroup,
  Button,
  Container,
} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { format, formatarMonetario } from '~/Utils/Helpers';
import { IoLogoWhatsapp } from 'react-icons/io';
import Loading from '~/Components/Loading';
import {
  PencilSimple,
  NotePencil,
  Envelope,
  Note,
  CalendarCheck,
  DeviceMobile,
  ArrowsClockwise,
  Scroll,
} from 'phosphor-react';
import {
  FaMapMarkedAlt,
  FaTag,
  FaTimes,
  FaGavel,
  FaCog,
  FaClipboardCheck,
  FaSync,
  FaRegCopy,
  FaStar,
} from 'react-icons/fa';
import './gestaoProspecto.css';
import ProspectoDetalhes from '../ProspectoDetalhes';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import InformacoesJuridicas from '~/Components/Juridico/InformacoesJuridicas';
import FormularioTarefas from '~/Components/FormularioTarefas';
import Anotacao from '~/Components/Anotacao/anotacao';
import * as api from '~/Services/Service';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import moment from 'moment';
import HistoricoProspecto from '../Historicos';
import Email from '~/Components/Email/email';
import { BsCircleFill } from 'react-icons/bs';
import FormularioVisita from '~/Components/FormularioVisita';
import AuthStorage from '~/Utils/AuthStorage';
import AtividadesTimeline from '../TimelineAtividadesProspecto';
import {
  TIPO_ATIVIDADE,
  PROVEDOR_CALENDARIO_EXTERNO,
  STATUS_CODE_OK,
  REGRA_FLUXOGRAMA_ETAPA,
  STATUS_ETAPAS_PROSPECTOS,
  PROSPECTO_STATUS_ENUM,
  CARACTERISTICA_GERENCIAR_SETCLUB,
  CODIGO_TIPO_PROSPECTO,
  caracteristicas,
  TIME_ZONE_PADRAO_AGENDA,
} from '~/constant';
import { getInitial } from '~/Utils/Helpers';
import CreatableSelect from 'react-select/async-creatable';
import { IconButton } from '@material-ui/core';
import { gerarAmbienteUrl } from '~/Pages/Vendas/helpers';
import { useSelector, useDispatch } from 'react-redux';
import { fetchMotivosDescarte } from '~/Store/Prospecto/actions';
import CardSituacaoDetalhada from '~/Components/StatusSituacaoCliente/CardSituacaoDetalhada';
import ModalUnificar from '../ModalUnificar';
import ModalAtualizacao from '../ModalAtualizacao';
import ModalAtividade from '../ModalAtividades';
import {
  solicitarTokenGoogleCalendar,
  solicitarTokenOutlookCalendar,
} from '~/Utils/CalendarioExterno';

const PERFIL_COMPRADOR_CONSTRUTOR = 1;
const PERFIL_COMPRADOR_INVESTIDOR = 3;
const PERFIS_COMPRADOR_SETCLUBE = [
  PERFIL_COMPRADOR_CONSTRUTOR,
  PERFIL_COMPRADOR_INVESTIDOR,
];

export default function LeadGestaoTela() {
  const codigoProspectoURL = useParams().codigo;
  const [prospecto, setProspecto] = useState(null);
  const [opcaoAdicional, setOpcaoAdicional] = useState(null);
  const [smsValues, setSmsValues] = useState({
    descricao: '',
    arquivo: null,
    telefone: '',
  });
  const [
    vinculoEmpreendimentoSelecionado,
    setVinculoEmpreendimentoSelecionado,
  ] = useState(null);
  const [opcoesEmpreendimentos, setOpcoesEmpreendimentos] = useState([]);
  const [editarProspecto, setEditarProspecto] = useState(false);
  const [exibirHistoricoProspecto, setExibirHistoricoProspecto] = useState(
    false
  );
  const [exibirModalDadosJuridicos, setExibirModalDadosJuridicos] = useState(
    false
  );
  const [salvandoDados, setSalvandoDados] = useState(false);
  const [salvandoSetclub, setSalvandoSetclub] = useState(false);
  const [
    mostrarModalPerfilSetclube,
    setMostrarModalPerfilSetclube,
  ] = useState(false);
  const [
    perfilSetclubeSelecionado,
    setPerfilSetclubeSelecionado,
  ] = useState(PERFIL_COMPRADOR_CONSTRUTOR);

  const [atividadeEditando, setAtividadeEditando] = useState(null);
  const [modalEdicaoTipo, setModalEdicaoTipo] = useState(null);

  const [anotacaoValues, setAnotacaoValues] = useState({
    descricao: '',
    arquivo: null,
  });
  const [qtdEmpreendimentosExibidos, setQtdEmpreendimentosExibidos] = useState(
    2
  );
  const [qtdPendenciasExibidas, setQtdPendenciasExibidas] = useState(1);
  const [mostrarModalTag, setMostrarModalTag] = useState(false);
  const [novaTag, setNovaTag] = useState(null);
  const [salvandoNovaTag, setSalvandoNovaTag] = useState(false);
  const [removendoTag, setRemovendoTag] = useState(false);
  const [mostrarModalUnificar, setMostrarModalUnificar] = useState(false);
  const [criarTag, setCriarTag] = useState('');
  const [criandoTag, setCriandoTag] = useState(false);
  const [expandido, setExpandido] = useState(false);
  const defaultToShow = 2;
  const total = opcoesEmpreendimentos.length;
  const hiddenCount = Math.max(total - defaultToShow, 0);
  const podeGerenciarSetclub = AuthStorage.temCaracteristica(
    CARACTERISTICA_GERENCIAR_SETCLUB
  );
  const [modoMobile, setModoMobile] = useState(window.innerWidth <= 768);
  const [etapasPermitidas, setEtapasPermitidas] = useState(null);
  const [mostrarModalTrocaEtapa, setMostrarModalTrocaEtapa] = useState(false);
  const [dadosModalTrocaEtapa, setDadosModalTrocaEtapa] = useState(null);
  const [atualizandoEtapa, setAtualizandoEtapa] = useState(false);
  const [
    mostrarModalTrocarResponsavel,
    setMostrarModalTrocarResponsavel,
  ] = useState(false);
  const [escalasDisponiveis, setEscalasDisponiveis] = useState([]);
  const [escalaSelecionada, setEscalaSelecionada] = useState(null);
  const [carregandoEscalas, setCarregandoEscalas] = useState(false);
  const [atribuindoResponsavel, setAtribuindoResponsavel] = useState(false);

  const [tipoAtribuicao, setTipoAtribuicao] = useState('fila');
  const [corretoresDisponiveis, setCorretoresDisponiveis] = useState([]);
  const [corretorSelecionado, setCorretorSelecionado] = useState(null);
  const [gestoresDisponiveis, setGestoresDisponiveis] = useState([]);
  const [gestorSelecionado, setGestorSelecionado] = useState(null);
  const [carregandoCorretores, setCarregandoCorretores] = useState(false);
  const [carregandoGestores, setCarregandoGestores] = useState(false);
  const gerentesCorretores = useSelector(state => state.corretor.listaGerentes);
  const options = useSelector(state => state.options);
  const dispatch = useDispatch();

  const [gerenteSelecionado, setGerenteSelecionado] = useState(null);
  const [gerentesFormatados, setGerentesFormatados] = useState([]);
  const [eventosTag, setEventosTag] = useState(false);
  const [exibirModalEventosTag, setExibirModalEventosTag] = useState(false);
  const [exibirModalEventos, setExibirModalEventos] = useState(false);
  const [eventosDisponiveis, setEventosDisponiveis] = useState([]);
  const [eventoSelecionado, setEventoSelecionado] = useState(null);
  const [carregandoEventos, setCarregandoEventos] = useState(false);

  const [podeDescartar, setPodeDescartar] = useState(false);
  const [motivoDescarte, setMotivoDescarte] = useState(null);
  const [dissertativaDescarte, setDissertativaDescarte] = useState('');
  const [dadosIndicacao, setDadosIndicacao] = useState(null);
  const [
    mostrarModalSituacaoCliente,
    setMostrarModalSituacaoCliente,
  ] = useState(false);
  const [mostrarModalAtualizacao, setMostrarModalAtualizacao] = useState(false);

  const [
    mostrarModalRemoverResponsavel,
    setMostrarModalRemoverResponsavel,
  ] = useState(false);
  const [tipoResponsavelRemocao, setTipoResponsavelRemocao] = useState(null);
  const [justificativaRemocao, setJustificativaRemocao] = useState('');
  const [removendoResponsavel, setRemovendoResponsavel] = useState(false);

  const isCavMaster = AuthStorage.temCaracteristicas([605]);

  const selecionarMotivoDescarte = value => setMotivoDescarte(value);
  const handleDissertativaDescarteChange = value =>
    setDissertativaDescarte(value);

  useEffect(() => {
    if (!vinculoEmpreendimentoSelecionado) return;
    (async () => {
      try {
        const response = await api.buscarEventosTag(
          vinculoEmpreendimentoSelecionado.codigo_familia
        );
        setEventosTag(response);
      } catch (error) {}
    })();
  }, [vinculoEmpreendimentoSelecionado]);
  useEffect(() => {}, [eventosTag]);
  useEffect(() => {
    const handleResize = () => {
      setModoMobile(window.innerWidth <= 770);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    buscarProspecto(codigoProspectoURL);
  }, []);

  useEffect(() => {
    const motivos = options && options.motivosDescarte;
    if (!motivos || motivos.length === 0) {
      dispatch(fetchMotivosDescarte());
    }
  }, [options && options.motivosDescarte]);

  useEffect(() => {
    if (prospecto) {
      const temVinculoReal = prospecto.prospecto_empreendimento.some(
        v => v.codigo_familia > 0
      );
      const vinculosFiltrados = temVinculoReal
        ? prospecto.prospecto_empreendimento.filter(v => v.codigo_familia > 0)
        : prospecto.prospecto_empreendimento;

      const empreendimentos = vinculosFiltrados.map(vinculo => ({
        value: vinculo,
        label: `${vinculo.codigo_familia} - ${vinculo.empreendimento.descricao}`,
      }));

      if (empreendimentos.length) {
        setOpcoesEmpreendimentos(empreendimentos);
        setVinculoEmpreendimentoSelecionado(empreendimentos.at(0).value);
        if (prospecto.codigo_origem_cadastro == 9) {
          api
            .buscarParametrosEmpreendimento(
              empreendimentos.at(0).value.codigo_familia
            )
            .then(res => {
              const vinculo = empreendimentos.at(0).value;
              const nomeCorretor =
                (vinculo && vinculo.nome_corretor) ||
                (vinculo &&
                  vinculo.corretor &&
                  (vinculo.corretor.nome || vinculo.corretor.descricao)) ||
                '';
              setDadosIndicacao({ ...res, nome_corretor: nomeCorretor });
            });
        }
      }
    }
  }, [prospecto]);

  useEffect(() => {
    if (vinculoEmpreendimentoSelecionado) {
      setEtapasPermitidas(
        REGRA_FLUXOGRAMA_ETAPA[vinculoEmpreendimentoSelecionado.codigo_status]
      );
      const vinculoValido =
        vinculoEmpreendimentoSelecionado.codigo_status !==
        PROSPECTO_STATUS_ENUM.descartado;
      const codigoUsuario = AuthStorage.getUser().usuario;
      if (
        vinculoValido &&
        (vinculoEmpreendimentoSelecionado.codigo_corretor == codigoUsuario ||
          vinculoEmpreendimentoSelecionado.codigo_gerente == codigoUsuario ||
          AuthStorage.isADM() ||
          AuthStorage.temCaracteristica(570)) &&
        vinculoEmpreendimentoSelecionado.codigo_status !==
          PROSPECTO_STATUS_ENUM.venda_realizada
      )
        setPodeDescartar(true);
    }
  }, [
    vinculoEmpreendimentoSelecionado &&
      vinculoEmpreendimentoSelecionado.codigo_status,
  ]);
  useEffect(() => {
    if (eventosTag && eventosTag.ativo && eventosTag.codigo_tag) {
      const tagJaVinculada =
        vinculoEmpreendimentoSelecionado &&
        vinculoEmpreendimentoSelecionado.tags.some(
          tag => tag.codigo === eventosTag.codigo_tag
        );

      if (!tagJaVinculada) {
        setExibirModalEventosTag(true);
      }
    }
  }, [eventosTag, vinculoEmpreendimentoSelecionado]);
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#007bff' : '#ced4da',
      boxShadow: state.isFocused
        ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)'
        : null,
      '&:hover': {
        borderColor: '#007bff',
      },
    }),
    menu: provided => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: provided => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#007bff'
        : state.isFocused
        ? '#f8f9fa'
        : null,
      color: state.isSelected ? 'white' : '#495057',
    }),
  };

  const abrirModalProspecto = () => {
    setEditarProspecto(true);
  };

  const fecharModalProspecto = () => {
    setEditarProspecto(false);
    buscarProspecto(codigoProspectoURL);
  };

  const prospectoTemPerfilSetclube = () => {
    if (!prospecto) return false;
    const codigoPerfilComprador = parseInt(
      prospecto.codigo_perfil_comprador,
      10
    );
    return PERFIS_COMPRADOR_SETCLUBE.includes(codigoPerfilComprador);
  };

  const parseIntOuNull = valor => {
    const numero = parseInt(valor, 10);
    return isNaN(numero) ? null : numero;
  };

  const removerNaoNumericos = valor =>
    valor ? `${valor}`.replace(/\D/g, '') : '';

  const normalizarValorMonetario = valor => {
    if (valor && typeof valor !== 'number') {
      const numero = parseFloat(
        `${valor}`.replace(/[^\d,]/g, '').replace(',', '.')
      );
      return isNaN(numero) ? null : numero;
    }

    return valor && typeof valor === 'number' ? valor : null;
  };

  const obterVinculoPrincipalProspecto = () => {
    if (vinculoEmpreendimentoSelecionado)
      return vinculoEmpreendimentoSelecionado;
    if (
      prospecto &&
      prospecto.prospecto_empreendimento &&
      prospecto.prospecto_empreendimento.length > 0
    ) {
      return prospecto.prospecto_empreendimento[0];
    }
    return {};
  };

  const montarRequestAtualizacaoPerfilSetclube = codigoPerfilComprador => {
    const vinculo = obterVinculoPrincipalProspecto();
    const request = {
      ...prospecto,
      codigo_tipo: CODIGO_TIPO_PROSPECTO,
      tipo_pessoa: parseIntOuNull(prospecto.tipo_pessoa),
      codigo_perfil_comprador: codigoPerfilComprador,
      tel_celular: removerNaoNumericos(prospecto.tel_celular),
      tel_comercial: removerNaoNumericos(prospecto.tel_comercial),
      tel_residencial: removerNaoNumericos(prospecto.tel_residencial),
      cpf: removerNaoNumericos(prospecto.cpf),
      cep: removerNaoNumericos(prospecto.cep),
      renda_familiar: normalizarValorMonetario(prospecto.renda_familiar),
      renda_pessoal: normalizarValorMonetario(prospecto.renda_pessoal),
      prospecto_empreendimento: [
        {
          codigo_familia:
            prospecto.codigo_familia || vinculo.codigo_familia || 0,
          codigo_corretor:
            prospecto.codigo_corretor || vinculo.codigo_corretor || 0,
          codigo_gerente:
            prospecto.codigo_gerente || vinculo.codigo_gerente || 0,
          codigo_conta: prospecto.codigo_conta || vinculo.codigo_conta || 0,
          dados_endereco_correspondencia: {
            codigo_grupo_empresa:
              prospecto.codigo_grupo_empresa ||
              vinculo.codigo_grupo_empresa ||
              0,
            endereco_correspondencia: prospecto.endereco_correspondencia,
            numero_correspondencia: prospecto.numero_correspondencia,
            bairro_correspondencia: prospecto.bairro_correspondencia,
            codigo_cidade_correspondencia:
              prospecto.codigo_cidade_correspondencia,
            complemento_correspondencia: prospecto.complemento_correspondencia,
            cep_correspondencia: prospecto.cep_correspondencia,
            flg_endereco_correspondencia:
              prospecto.flg_endereco_correspondencia,
          },
          senha: 0,
        },
      ],
      codigo_perfil_exterior: parseIntOuNull(
        prospecto.codigo_perfil_exterior
      ),
    };

    delete request.documentos;

    for (const key in request) {
      if (request[key] === '') {
        request[key] = null;
      }
    }

    return request;
  };

  const confirmarAtualizacaoPerfilSetclube = async () => {
    if (!prospecto || salvandoSetclub) return;

    const codigoPerfilComprador = parseIntOuNull(perfilSetclubeSelecionado);
    if (!PERFIS_COMPRADOR_SETCLUBE.includes(codigoPerfilComprador)) {
      toast.error('Selecione Construtor ou Investidor.');
      return;
    }

    setSalvandoSetclub(true);
    try {
      const request = montarRequestAtualizacaoPerfilSetclube(
        codigoPerfilComprador
      );
      await api.atualizarProspecto(request);
      await api.atualizarSetclubProspecto(prospecto.codigo, true);
      setProspecto(prev => ({
        ...prev,
        codigo_perfil_comprador: codigoPerfilComprador,
        is_setclub: true,
      }));
      setMostrarModalPerfilSetclube(false);
      toast.success('Perfil atualizado e prospecto marcado como SetClube');
      buscarProspecto(codigoProspectoURL);
    } catch (err) {
      toast.error(
        err && err.message
          ? err.message
          : 'Erro ao atualizar prospecto para SetClube'
      );
    } finally {
      setSalvandoSetclub(false);
    }
  };

  const toggleHistoricoProspecto = () => {
    setExibirHistoricoProspecto(!exibirHistoricoProspecto);
  };

  const toggleExibirModalDadosJuridicos = () => {
    setExibirModalDadosJuridicos(!exibirModalDadosJuridicos);
  };

  const toggleModalUnificarProspecto = () => {
    setMostrarModalUnificar(!mostrarModalUnificar);
  };

  const alterarSetclubProspecto = async () => {
    if (!prospecto || salvandoSetclub) return;

    const proximoValor = !prospecto.is_setclub;

    if (proximoValor && !prospectoTemPerfilSetclube()) {
      setPerfilSetclubeSelecionado(PERFIL_COMPRADOR_CONSTRUTOR);
      setMostrarModalPerfilSetclube(true);
      return;
    }

    setSalvandoSetclub(true);
    try {
      await api.atualizarSetclubProspecto(prospecto.codigo, proximoValor);
      setProspecto(prev => ({
        ...prev,
        is_setclub: proximoValor,
      }));
      toast.success(
        proximoValor
          ? 'Prospecto marcado como SetClube'
          : 'Prospecto removido do SetClube'
      );
    } catch (err) {
      toast.error(
        err && err.message ? err.message : 'Erro ao atualizar SetClube'
      );
    } finally {
      setSalvandoSetclub(false);
    }
  };

  const toggleModalSituacaoCliente = () => {
    setMostrarModalSituacaoCliente(!mostrarModalSituacaoCliente);
  };

  const toggleModalAtualizacao = () => {
    setMostrarModalAtualizacao(!mostrarModalAtualizacao);
  };

  const buscarProspecto = async codigo => {
    try {
      let response = await api.getProspecto(codigo, false);
      if (response) {
        setProspecto(response);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const atividadeEtapaStringToEnum = situacao => {
    switch (situacao) {
      case 'Pendente':
        return 1;
      case 'Concluído':
        return 2;
      case 'Em Andamento':
        return 3;
      case 'Cancelado':
        return 4;
      case 'Vencido':
        return 5;
    }
  };

  const montarDescricaoEventoExterno = (dados, novaAtividade) => {
    const linhas = [
      dados.descricao ? `Descrição: ${dados.descricao}` : '',
      prospecto && prospecto.nome ? `Lead: ${prospecto.nome}` : '',
      vinculoEmpreendimentoSelecionado &&
      vinculoEmpreendimentoSelecionado.empreendimento
        ? `Empreendimento: ${vinculoEmpreendimentoSelecionado.empreendimento.descricao}`
        : '',
      novaAtividade && novaAtividade.codigo_atividade
        ? `Atividade REVO: ${novaAtividade.codigo_atividade}`
        : '',
    ];

    return linhas.filter(linha => linha).join('\n');
  };

  const obterTokenCalendarioExterno = async dados => {
    const provedor = dados.sincronizarCalendario;

    if (
      !provedor ||
      provedor === PROVEDOR_CALENDARIO_EXTERNO.NENHUM ||
      !dados.data
    ) {
      return null;
    }

    return provedor === PROVEDOR_CALENDARIO_EXTERNO.GOOGLE
      ? await solicitarTokenGoogleCalendar()
      : await solicitarTokenOutlookCalendar();
  };

  const sincronizarCalendarioExterno = async (
    dados,
    tipoAtividade,
    novaAtividade,
    tokenCalendarioExterno
  ) => {
    const provedor = dados.sincronizarCalendario;

    if (!tokenCalendarioExterno) {
      return null;
    }

    const inicio = moment(dados.data, 'YYYY-MM-DD HH:mm', true);
    if (!inicio.isValid()) {
      throw new Error('Data da atividade inválida para agenda externa.');
    }

    const duracaoMinutos = tipoAtividade === TIPO_ATIVIDADE.VISITA ? 60 : 30;
    const fim = inicio.clone().add(duracaoMinutos, 'minutes');
    const titulo =
      tipoAtividade === TIPO_ATIVIDADE.VISITA
        ? `Visita - ${prospecto.nome}`
        : `Tarefa - ${prospecto.nome}`;

    return api.criarEventoCalendarioExterno({
      provedor: provedor === PROVEDOR_CALENDARIO_EXTERNO.GOOGLE ? 1 : 2,
      access_token: tokenCalendarioExterno.access_token,
      calendar_id: tokenCalendarioExterno.calendar_id,
      codigo_atividade: novaAtividade.codigo_atividade,
      titulo,
      descricao: montarDescricaoEventoExterno(dados, novaAtividade),
      local: dados.pdv || '',
      data_inicial: inicio.format('YYYY-MM-DDTHH:mm:ss'),
      data_final: fim.format('YYYY-MM-DDTHH:mm:ss'),
      time_zone: TIME_ZONE_PADRAO_AGENDA,
    });
  };

  const fecharModais = () => {
    setModalEdicaoTipo(null);
    setAtividadeEditando(null);
    setOpcaoAdicional('');
  };

  const salvarFormulario = async (dados, tipoAtividade, editando) => {
    const limparDados = dados => {
      if (Object.keys(dados).includes('tarefaInternaValues')) {
        const tarefaInternaValues = dados['tarefaInternaValues'];
        delete dados['tarefaInternaValues'];
        return tarefaInternaValues;
      }
      return '';
    };

    const extrairArquivo = dados => {
      if (dados.arquivo) {
        const arquivo = dados.arquivo;
        delete dados.arquivo;
        return arquivo;
      }
      return null;
    };

    try {
      setSalvandoDados(true);
      const tarefaInternaValues = limparDados(dados);
      const arquivo = extrairArquivo(dados);
      var request = {
        tipo_atividade: tipoAtividade,
        atividade_etapa: atividadeEtapaStringToEnum(dados.situacao),
        descricao_atividade: JSON.stringify(dados),
        codigo_prospecto: vinculoEmpreendimentoSelecionado.codigo_prospecto,
        nome_prospecto: prospecto.nome,
        codigo_familia: vinculoEmpreendimentoSelecionado.codigo_familia,
        nome_familia: vinculoEmpreendimentoSelecionado.empreendimento.descricao,
        codigo_usuario: AuthStorage.getUser().usuario,
        codigo_atividade: null,
        data_conclusao: dados.data,
        codigo_responsavel: dados.responsavel
          ? dados.responsavel.split('-')[0].trim()
          : null,
        codigo_vinculo_atividade: dados.codigo_vinculo_atividade || '',
      };

      if (editando) {
        request = {
          ...request,
          codigo_atividade: dados.codigoAtividade,
        };
      }

      let tokenCalendarioExterno = null;
      if (
        !editando &&
        (tipoAtividade === TIPO_ATIVIDADE.TAREFA ||
          tipoAtividade === TIPO_ATIVIDADE.VISITA)
      ) {
        try {
          tokenCalendarioExterno = await obterTokenCalendarioExterno(dados);
        } catch (error) {
          const mensagemErro =
            error && error.message
              ? `Não foi possível autenticar na agenda externa: ${error.message}. A atividade será salva apenas no REVO.`
              : 'Não foi possível autenticar na agenda externa. A atividade será salva apenas no REVO.';

          console.error('Erro ao autenticar na agenda externa:', error);
          toast.error(mensagemErro);
        }
      }

      let response;
      if (arquivo && tipoAtividade === TIPO_ATIVIDADE.ANOTACAO && !editando) {
        response = await api.salvarAtividadeComAnexo(request, arquivo);
      } else {
        response = editando
          ? await api.editarAtividade(request)
          : await api.salvarAtividade(request);
      }

      if (response.status === STATUS_CODE_OK) {
        if (tarefaInternaValues) {
          salvarFormulario(
            {
              ...tarefaInternaValues,
              codigo_vinculo_atividade:
                response.nova_atividade.codigo_atividade,
            },
            TIPO_ATIVIDADE.TAREFA,
            editando
          );
        }
        fecharModais();
        if (!tarefaInternaValues) {
          if (request.tipo_atividade === 3 || request.tipo_atividade === 5) {
            if (prospecto.etapa_terreno_construcao < parseInt('4')) {
              try {
                await api.atualizarEtapaConstrucaoProspecto({
                  codigo_prospecto: String(request.codigo_prospecto),
                  etapa_atual: String(prospecto.etapa_terreno_construcao),
                  nova_etapa: '4',
                });
                toast.success('Etapa do prospecto atualizada.');
              } catch (error) {
                console.error('Erro ao atualizar etapa do prospecto:', error);
              }
            }
          }
          if (
            !editando &&
            (request.tipo_atividade === TIPO_ATIVIDADE.TAREFA ||
              request.tipo_atividade === TIPO_ATIVIDADE.VISITA)
          ) {
            try {
              const calendarioExterno = await sincronizarCalendarioExterno(
                dados,
                tipoAtividade,
                response.nova_atividade,
                tokenCalendarioExterno
              );
              if (calendarioExterno && calendarioExterno.sincronizado) {
                toast.success('Evento criado na agenda externa.');
              }
            } catch (error) {
              toast.error(
                'Atividade criada, mas não foi possível sincronizar com a agenda externa.'
              );
            }
          }
          toast.success(
            `Atividade ${editando ? 'editada' : 'criada'} com sucesso.`
          );

          // Notifica outras abas que uma atividade foi criada/editada
          try {
            localStorage.setItem(
              'kanban_reload_trigger',
              Date.now().toString()
            );
          } catch (error) {
            console.error('Erro ao notificar atualização:', error);
          }
        }
        if (!editando) {
          vinculoEmpreendimentoSelecionado.atividades = [
            ...vinculoEmpreendimentoSelecionado.atividades,
            response.nova_atividade,
          ].sort((a, b) => b.codigo_atividade - a.codigo_atividade);
        } else {
          vinculoEmpreendimentoSelecionado.atividades = vinculoEmpreendimentoSelecionado.atividades.map(
            atividade =>
              atividade.codigo_atividade ===
              response.nova_atividade.codigo_atividade
                ? response.nova_atividade
                : atividade
          );
        }
      }
    } catch (error) {
      toast.error(`Erro ao ${editando ? 'editar' : 'criar'} atividade`);
    } finally {
      setSalvandoDados(false);
    }
  };

  useEffect(() => {
    setQtdEmpreendimentosExibidos(expandido ? total : defaultToShow);
  }, [expandido, total]);

  const buscarEventos = async () => {
    try {
      setCarregandoEventos(true);
      const response = await api.buscarTodosEventos();

      const eventosFormatados = response.map((evento, index) => ({
        value: `${evento.codigo_familia}-${evento.codigo_tag}-${index}`,
        label: evento.nome_evento,
        codigo_familia: evento.codigo_familia,
        codigo_tag: evento.codigo_tag,
        nome_familia: evento.nome_familia,
        nome_tag: evento.nome_tag,
        data_inicial: evento.data_inicial,
        data_final: evento.data_final,
        ativo: evento.ativo,
      }));

      setEventosDisponiveis(eventosFormatados);
    } catch (error) {
      toast.error('Erro ao carregar eventos.');
      console.error('Erro ao buscar eventos:', error);
    } finally {
      setCarregandoEventos(false);
    }
  };

  const abrirModalEventos = () => {
    setExibirModalEventos(true);
    buscarEventos();
  };

  const fecharModalEventos = () => {
    setExibirModalEventos(false);
    setEventoSelecionado(null);
    setEventosDisponiveis([]);
  };

  const handleToggleExpand = () => {
    setExpandido(prev => !prev);
  };

  const handleChangeVinculo = selectedOption => {
    const { value } = selectedOption;
    setVinculoEmpreendimentoSelecionado(value);
    setExpandido(false);
    setOpcoesEmpreendimentos(prev => moveEmpreendimentoToTop(prev, value));
  };

  const moveEmpreendimentoToTop = (array, selectedValue) => {
    const items = [...array];

    const idx = items.findIndex(item => item.value === selectedValue);
    let selectedItem;
    if (idx !== -1) {
      [selectedItem] = items.splice(idx, 1);
    }

    items.sort(
      (a, b) => new Date(b.value.data_vinculo) - new Date(a.value.data_vinculo)
    );

    if (!selectedItem) return items;
    return [selectedItem, ...items];
  };

  const AtualizarStatusLeadBolsao = status => {
    setSalvandoDados(true);
    api
      .AtualizarStatusLeadBolsao(
        prospecto.codigo,
        vinculoEmpreendimentoSelecionado.codigo_familia,
        status
      )
      .then(response => {
        response && toast.success('lead inserido com sucesso no bolsão');
        setProspecto(prev => ({
          ...prev,
          flag_represado_bolsao: status,
        }));
      })
      .catch(error => {
        toast.error(error.message);
      })
      .finally(() => {
        setSalvandoDados(false);
      });
  };

  const buscarTagsAutocomplete = async descricao => {
    if (!descricao) return [];

    try {
      let response = await api.buscarTagsAutocomplete(descricao);

      return response.map(tag => ({
        label: tag.descricao,
        value: tag.codigo,
      }));
    } catch (error) {
      toast.error(error.message);
      return [];
    }
  };

  const vincularNovaTag = async novaTag => {
    try {
      setSalvandoNovaTag(true);

      let response = await api.vincularTag({
        codigo_familia: vinculoEmpreendimentoSelecionado.codigo_familia,
        codigo_prospecto: vinculoEmpreendimentoSelecionado.codigo_prospecto,
        codigo_tag: novaTag.value,
      });

      if (response) {
        toast.success(response.message);
        vinculoEmpreendimentoSelecionado.tags = response.tags;
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setSalvandoNovaTag(false);
    }
  };

  const removerTag = async tag => {
    try {
      setRemovendoTag(true);

      let response = await api.removerTag({
        codigo_familia: vinculoEmpreendimentoSelecionado.codigo_familia,
        codigo_prospecto: vinculoEmpreendimentoSelecionado.codigo_prospecto,
        codigo_tag: tag.codigo,
      });

      if (response) {
        toast.success(response.message);
        vinculoEmpreendimentoSelecionado.tags = response.tags;
      }
    } catch (error) {
      toast.error(error.messa1ge);
    } finally {
      setRemovendoTag(false);
    }
  };

  const criarEVincularTagAutocomplete = async () => {
    try {
      setCriandoTag(true);
      const response = await api.InserirTagAtendimento({ descricao: criarTag });
      vincularNovaTag({ value: response.codigo });
      setMostrarModalTag(false);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setCriandoTag(false);
    }
  };

  const podeMostrarModalAtualizarProspectoGES = () => {
    if (!vinculoEmpreendimentoSelecionado) return false;

    // Cliente GES sem prospecto (NULL/0) tambem pode ser vinculado, como no ERP.
    const codigoProspectoGes =
      vinculoEmpreendimentoSelecionado.codigo_prospecto_cliente_joia || 0;

    if (
      !codigoProspectoGes &&
      !vinculoEmpreendimentoSelecionado.cliente_joia_encontrado
    )
      return false;

    if (
      vinculoEmpreendimentoSelecionado.codigo_prospecto !== codigoProspectoGes
    ) {
      if (AuthStorage.temCaracteristica(caracteristicas.SecVendas)) {
        return true;
      }
    }

    return false;
  };

  const fecharModalAtualizarEtapa = () => {
    setMostrarModalTrocaEtapa(false);
    setDadosModalTrocaEtapa(null);
  };

  const atualizarEtapaProspecto = async dados => {
    try {
      setAtualizandoEtapa(true);
      const atualizarPayload = {
        codigo_prospecto: dados.codigo_prospecto,
        codigo_familia: dados.codigo_familia,
        etapa_atual: dados.etapa_atual,
        nova_etapa: dados.nova_etapa,
      };

      if (dados.nova_etapa === PROSPECTO_STATUS_ENUM.descartado) {
        if (!podeDescartar) {
          throw new Error('SEM_PERMISSAO_DESCARTE');
        }
        if (!dados.codigo_motivo_descarte) {
          toast.error('Selecione um motivo para descartar.');
          return;
        }
        const removerPayload = {
          codigo_prospecto: dados.codigo_prospecto,
          codigo_familia: dados.codigo_familia,
          codigo_motivo_descarte: dados.codigo_motivo_descarte,
          justificativa: dados.justificativa,
        };
        await api.removerEmpreendimento(removerPayload);
        vinculoEmpreendimentoSelecionado.codigo_status = dados.nova_etapa;
        toast.success('Empreendimento removido e etapa atualizada.');
      } else {
        const responseAtualizar = await api.atualizarEtapaProspecto(
          atualizarPayload
        );
        if (responseAtualizar.status === STATUS_CODE_OK) {
          vinculoEmpreendimentoSelecionado.codigo_status = dados.nova_etapa;
          toast.success('Etapa atualizada com sucesso.');
        } else {
          throw new Error('ATUALIZAR_ETAPA_ERRO_STATUS');
        }
      }
    } catch (error) {
      if (error && error.message === 'SEM_PERMISSAO_DESCARTE') {
        toast.error('Você não tem permissão para descartar.');
      } else {
        toast.error('Erro ao atualizar etapa.');
      }
    } finally {
      setAtualizandoEtapa(false);
      fecharModalAtualizarEtapa();
    }
  };

  const abrirModalTrocarResponsavel = async () => {
    try {
      setMostrarModalTrocarResponsavel(true);
      setTipoAtribuicao('fila');

      setCarregandoEscalas(true);
      const parametroBusca = vinculoEmpreendimentoSelecionado.codigo_familia;

      if (parametroBusca) {
        const escalas = await api.BuscarEscalasParaFila(parametroBusca);
        const escalasFormatadas = escalas.map(escala => ({
          value: escala.codigo_escala,
          label: escala.descricao,
        }));
        setEscalasDisponiveis(escalasFormatadas);
      } else {
        toast.error(
          'Não foi possível identificar o empreendimento para buscar as escalas.'
        );
      }
      setCarregandoEscalas(false);

      let gerentesFormatadosData = [];
      if (gerentesCorretores && gerentesCorretores.length > 0) {
        gerentesFormatadosData = gerentesCorretores.map(gerente => ({
          value: gerente.codigo,
          label: gerente.nome,
          corretores: gerente.corretores || [],
        }));
        setGerentesFormatados(gerentesFormatadosData);
      }

      const corretorAtivo = obterCorretorGerenteAtivoDoLead();
      if (corretorAtivo) {
        setTipoAtribuicao('corretor');
        const gerenteOpt = gerentesFormatadosData.find(
          g => g.value === corretorAtivo.codigo_gerente
        );
        if (gerenteOpt) {
          setGerenteSelecionado(gerenteOpt);
          const corretorOpt = (gerenteOpt.corretores || [])
            .map(c => ({ value: c.codigo, label: c.nome }))
            .find(c => c.value === corretorAtivo.codigo_corretor);
          if (corretorOpt) setCorretorSelecionado(corretorOpt);
        }
      }

      setCarregandoGestores(true);
      try {
        const atendentes = await api.BuscarAtendentesCAV(parametroBusca);
        const atendentesFormatados = atendentes.map(atendente => ({
          value: atendente.codigo,
          label: atendente.nome,
        }));
        setGestoresDisponiveis(atendentesFormatados);
      } catch (error) {
        console.error('Erro ao buscar atendentes:', error);
        setGestoresDisponiveis([]);
      } finally {
        setCarregandoGestores(false);
      }
    } catch (error) {
      console.error('Erro ao abrir modal:', error);
      toast.error('Erro ao carregar dados.');
      setCarregandoEscalas(false);
      setCarregandoCorretores(false);
      setCarregandoGestores(false);
    }
  };

  const filtrarCorretoresPorGerente = gerente => {
    if (!gerente || !gerente.corretores) {
      return corretoresDisponiveis;
    }

    const corretoresDoGerente = gerente.corretores.map(corretor => ({
      value: corretor.codigo,
      label: corretor.nome,
    }));

    return corretoresDoGerente;
  };

  const fecharModalTrocarResponsavel = () => {
    setMostrarModalTrocarResponsavel(false);
    setEscalasDisponiveis([]);
    setEscalaSelecionada(null);
    setCorretoresDisponiveis([]);
    setCorretorSelecionado(null);
    setGestoresDisponiveis([]);
    setGestorSelecionado(null);
    setGerenteSelecionado(null);
    setGerentesFormatados([]);
    setTipoAtribuicao('fila');
  };

  const atribuirNovoResponsavel = async () => {
    if (tipoAtribuicao === 'fila' && !escalaSelecionada) {
      toast.error('Selecione uma escala para continuar.');
      return;
    }
    if (
      tipoAtribuicao === 'corretor' &&
      (!gerenteSelecionado || !corretorSelecionado)
    ) {
      toast.error('Selecione um gerente e um corretor para continuar.');
      return;
    }
    if (tipoAtribuicao === 'gestor' && !gestorSelecionado) {
      toast.error('Selecione um atendente para continuar.');
      return;
    }

    try {
      setAtribuindoResponsavel(true);

      switch (tipoAtribuicao) {
        case 'fila':
          await api.AtribuirCorretorFila({
            codigo_escala: escalaSelecionada.value,
            codigo_prospecto: prospecto.codigo,
            codigo_familia: vinculoEmpreendimentoSelecionado.codigo_familia,
          });
          toast.success('Prospecto atribuído à fila com sucesso!');
          break;
        case 'corretor':
          await api.AtribuirCorretorManual({
            codigo_corretor: corretorSelecionado.value,
            codigo_prospecto: prospecto.codigo,
            codigo_familia: vinculoEmpreendimentoSelecionado.codigo_familia,
          });
          toast.success(
            `Prospecto atribuído ao corretor ${corretorSelecionado.label} com sucesso!`
          );
          break;
        case 'gestor':
          await api.AtribuirAtendenteCAV({
            codigo_prospecto: prospecto.codigo,
            codigo_atendente: gestorSelecionado.value,
            codigo_familia: vinculoEmpreendimentoSelecionado.codigo_familia,
          });
          toast.success(
            `Prospecto atribuído ao atendente ${gestorSelecionado.label} com sucesso!`
          );
          break;
        default:
          toast.error('Tipo de atribuição inválido.');
          return;
      }

      fecharModalTrocarResponsavel();

      buscarProspecto(codigoProspectoURL);
    } catch (error) {
      console.error('Erro ao atribuir responsável:', error);
      toast.error(`${error.message}`);
    } finally {
      setAtribuindoResponsavel(false);
    }
  };

  const copiarTexto = async texto => {
    try {
      await navigator.clipboard.writeText(texto || '');
      toast.success('Copiado');
      return true;
    } catch (err) {
      toast.error('Erro ao copiar');
      return false;
    }
  };

  const desabilitarFuncionalidades = () => {
    if (AuthStorage.isADM() || AuthStorage.isCAV()) return false;
    if (
      vinculoEmpreendimentoSelecionado &&
      vinculoEmpreendimentoSelecionado.codigo_corretor !==
        AuthStorage.getUser().usuario
    ) {
      return true;
    }
    return false;
  };

  const obterCorretorGerenteAtivoDoLead = () => {
    if (!opcoesEmpreendimentos || opcoesEmpreendimentos.length === 0)
      return null;
    const opcaoAtiva = opcoesEmpreendimentos.find(
      op =>
        op &&
        op.value &&
        op.value.codigo_corretor > 0 &&
        op.value.codigo_gerente > 0 &&
        op.value.codigo_status !== PROSPECTO_STATUS_ENUM.descartado &&
        !op.value.respeitar_corretor_escolhido
    );
    if (!opcaoAtiva) return null;
    const vinculo = opcaoAtiva.value;
    const nomeCorretor =
      vinculo.corretor && vinculo.corretor.nome
        ? vinculo.corretor.nome
        : vinculo.nome_corretor || '';
    const nomeGerente =
      vinculo.gerente && vinculo.gerente.nome ? vinculo.gerente.nome : '';
    return {
      codigo_corretor: vinculo.codigo_corretor,
      codigo_gerente: vinculo.codigo_gerente,
      nome_corretor: nomeCorretor,
      nome_gerente: nomeGerente,
    };
  };

  const abrirModalRemoverResponsavel = tipo => {
    setTipoResponsavelRemocao(tipo);
    setJustificativaRemocao('');
    setMostrarModalRemoverResponsavel(true);
  };

  const fecharModalRemoverResponsavel = () => {
    setMostrarModalRemoverResponsavel(false);
    setTipoResponsavelRemocao(null);
    setJustificativaRemocao('');
  };

  const getLabelTipoResponsavel = tipo => {
    switch (tipo) {
      case 'gestor':
        return 'Gestor';
      case 'imobiliaria':
        return 'Imobiliária';
      case 'corretor':
        return 'Corretor';
      default:
        return '';
    }
  };

  const confirmarRemocaoResponsavel = async () => {
    if (!justificativaRemocao.trim()) {
      toast.error('Informe a justificativa para remoção.');
      return;
    }

    try {
      setRemovendoResponsavel(true);

      await api.removerResponsavelProspecto({
        codigo_prospecto: prospecto.codigo,
        codigo_familia: vinculoEmpreendimentoSelecionado.codigo_familia,
        tipo_remocao: tipoResponsavelRemocao,
        justificativa: justificativaRemocao,
      });

      const mensagem =
        tipoResponsavelRemocao === 'imobiliaria'
          ? 'Imobiliária e Corretor removidos com sucesso!'
          : `${getLabelTipoResponsavel(
              tipoResponsavelRemocao
            )} removido com sucesso!`;

      toast.success(mensagem);
      fecharModalRemoverResponsavel();
      buscarProspecto(codigoProspectoURL);
    } catch (error) {
      console.error('Erro ao remover responsável:', error);
      toast.error('Erro ao remover responsável.');
    } finally {
      setRemovendoResponsavel(false);
    }
  };

  const renderDadosVinculo = vinculo => {
    if (!vinculo) return null;

    const { gerente, imobiliaria, corretor, data_vinculo } = vinculo;
    const usuario_cav = prospecto && prospecto.usuario_cav;

    const nomeGestor = (usuario_cav && usuario_cav.nome_usuario_cav) || null;
    const nomeImobiliaria = (imobiliaria && imobiliaria.nome) || null;
    const nomeCorretor = (corretor && corretor.nome) || null;

    return (
      <ListGroup size="sm" className="mb-2">
        <ListGroup.Item className="mt-2 d-flex align-items-center">
          <div className="circle-perfil ">{getInitial(nomeGestor, true)}</div>
          <div className="ml-2 w-100">
            <div className="d-flex  justify-content-between force-block-content">
              <div>
                <span className="pill pill-green">Gestor</span>
              </div>
              {isCavMaster && nomeGestor && (
                <FaTimes
                  className="text-danger"
                  style={{ cursor: 'pointer', fontSize: '14px' }}
                  title="Remover Gestor"
                  onClick={() => abrirModalRemoverResponsavel('gestor')}
                />
              )}
            </div>
            <div className="fw-bold">{nomeGestor || 'Não informado'}</div>
          </div>
        </ListGroup.Item>
        <ListGroup.Item className="mt-2 d-flex align-items-center">
          <div className="circle-perfil">
            {getInitial(nomeImobiliaria, true)}
          </div>
          <div className="ml-2 w-100">
            <div className="d-flex  justify-content-between force-block-content">
              <div>
                <span className="pill pill-orange">Imobiliária</span>
              </div>
              <div className="d-flex align-items-center">
                <div className="text-muted small text-truncat">
                  {data_vinculo
                    ? format.date(data_vinculo, 'DD/MM/YYYY - HH:mm')
                    : 'Sem vínculo'}
                </div>
                {isCavMaster && nomeImobiliaria && (
                  <FaTimes
                    className="text-danger ml-2"
                    style={{ cursor: 'pointer', fontSize: '14px' }}
                    title="Remover Imobiliária"
                    onClick={() => abrirModalRemoverResponsavel('imobiliaria')}
                  />
                )}
              </div>
            </div>

            <div className="fw-bold">{nomeImobiliaria || 'Não informado'}</div>
          </div>
        </ListGroup.Item>
        <ListGroup.Item className="mt-2 d-flex align-items-center">
          <div className="circle-perfil ">{getInitial(nomeCorretor, true)}</div>
          <div className="ml-2 w-100">
            <div className="d-flex justify-content-between force-block-content">
              <div>
                <span className="pill pill-blue">Corretor</span>
              </div>
              <div className="d-flex align-items-center">
                <div className="text-muted small text-truncat">
                  {data_vinculo
                    ? format.date(data_vinculo, 'DD/MM/YYYY - HH:mm')
                    : 'Sem vínculo'}
                </div>
                {isCavMaster && nomeCorretor && (
                  <FaTimes
                    className="text-danger ml-2"
                    style={{ cursor: 'pointer', fontSize: '14px' }}
                    title="Remover Corretor"
                    onClick={() => abrirModalRemoverResponsavel('corretor')}
                  />
                )}
              </div>
            </div>
            <div className="fw-bold">{nomeCorretor || 'Não informado'}</div>
          </div>
        </ListGroup.Item>
      </ListGroup>
    );
  };

  function getTipoAtividadeTexto(tipo) {
    switch (tipo) {
      case TIPO_ATIVIDADE.ANOTACAO:
        return 'uma anotação';
      case TIPO_ATIVIDADE.EMAIL:
        return 'um E-mail';
      case TIPO_ATIVIDADE.SMS:
        return 'um SMS';
      default:
        return 'uma atividade';
    }
  }

  const estiloCardProspecto =
    prospecto && prospecto.is_setclub
      ? {
          border: '2px solid #d4af37',
          borderRadius: 8,
          boxShadow: '0 0 10px rgba(118, 99, 15, 0.25)',
        }
      : prospecto && prospecto.interesse_social
      ? {
          border: '2px solid #ff9800',
          borderRadius: 8,
          boxShadow: '0 0 8px rgba(255,152,0,0.25)',
        }
      : {};

  return (
    <Container fluid className="bg-white h-100 gestao-prospecto-container">
      {prospecto !== null && (
        <Row>
          <Col md={12} sm={12} lg={3} xl={3} className="mb-3">
            <Card
              className="card-responsive"
              style={{ border: 'none', boxShadow: 'none' }}
            >
              <Card.Body className="p-0">
                <div
                  className="div-card"
                  style={estiloCardProspecto}
                >
                  <div className="d-flex align-items-start mb-3">
                    <div className="circle-perfil flex-shrink-0">
                      {getInitial(prospecto.nome)}
                    </div>
                    <div className="ms-3 ml-2" style={{ minWidth: 0, flex: 1 }}>
                      <div
                        className="fw-bold text-primary"
                        style={{
                          wordBreak: 'break-word',
                          whiteSpace: 'normal',
                        }}
                      >
                        {prospecto.nome}
                      </div>
                      <div
                        className="text-muted small"
                        style={{
                          wordBreak: 'break-word',
                          whiteSpace: 'normal',
                        }}
                      >
                        {prospecto.email}
                      </div>
                      <div
                        className="text-muted small"
                        style={{
                          wordBreak: 'break-word',
                          whiteSpace: 'normal',
                        }}
                      >
                        {format.celular(prospecto.tel_celular) || ''}
                      </div>
                      <div
                        className="text-muted small"
                        style={{
                          wordBreak: 'break-word',
                          whiteSpace: 'normal',
                          cursor: 'pointer',
                        }}
                        onMouseEnter={e => {
                          e.target.style.textDecoration = 'underline';
                        }}
                        onMouseLeave={e => {
                          e.target.style.textDecoration = '';
                        }}
                        onClick={() => copiarTexto(prospecto.codigo)}
                      >
                        {prospecto.codigo || ''}
                      </div>
                      {prospecto.is_setclub && (
                        <div className="mt-2">
                          <span
                            className="d-inline-flex align-items-center"
                            style={{
                              backgroundColor: '#fbf8ccff',
                              border: '1px solid #d4af37',
                              borderRadius: 4,
                              color: '#a88c2fff',
                              fontSize: 12,
                              fontWeight: 700,
                              padding: '2px 8px',
                            }}
                          >
                            <FaStar size={12} className="mr-1" />
                            Cliente SetClube
                          </span>
                        </div>
                      )}
                      {prospecto.codigo_origem_cadastro == 9 && dadosIndicacao && (
                        <div>
                          <small>
                            Prospecto indicado por{' '}
                            <b>
                              {(dadosIndicacao &&
                                dadosIndicacao.nome_corretor) ||
                                ''}
                            </b>{' '}
                            <b>
                              Custo{' '}
                              {formatarMonetario(
                                dadosIndicacao.valor_desconto_cliente
                              )}{' '}
                            </b>
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                  {!desabilitarFuncionalidades() && (
                    <>
                      {prospecto.flag_represado_bolsao === true ? (
                        <Button
                          className="mb-2 ml-2"
                          variant="outline-danger"
                          size="sm"
                          onClick={() => AtualizarStatusLeadBolsao(false)}
                          disabled={salvandoDados}
                        >
                          Remover do bolsão
                        </Button>
                      ) : (
                        <Button
                          className="mb-2 ml-2"
                          variant="outline-primary"
                          size="sm"
                          onClick={() => AtualizarStatusLeadBolsao(true)}
                          disabled={salvandoDados}
                        >
                          Inserir no bolsão
                        </Button>
                      )}
                    </>
                  )}
                  {vinculoEmpreendimentoSelecionado && (
                    <>
                      <Button
                        className="mb-2 ml-2"
                        variant={`outline-${
                          vinculoEmpreendimentoSelecionado.codigo_familia
                            ? 'success'
                            : 'danger'
                        }`}
                        size="sm"
                        target="blank"
                        href={
                          AuthStorage.temCaracteristica(584)
                            ? '#'
                            : `/mapa-empreendimento?prospecto=${prospecto.codigo}&familia=${vinculoEmpreendimentoSelecionado.codigo_familia}`
                        }
                        disabled={
                          !vinculoEmpreendimentoSelecionado.codigo_familia ||
                          salvandoDados ||
                          AuthStorage.temCaracteristica(584)
                        }
                      >
                        <FaMapMarkedAlt />
                        <span className="ml-xl-1 d-none d-xl-inline">
                          Reservar Lote
                        </span>
                      </Button>
                    </>
                  )}

                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="mb-2 ml-2"
                    title="Editar Prospecto"
                    onClick={() => {
                      abrirModalProspecto();
                    }}
                  >
                    <PencilSimple size={18} />
                  </Button>

                  {prospecto.interesse_social && (
                    <div
                      className="d-flex align-items-center mt-2 mb-1 justify-content-end"
                      style={{ gap: 6 }}
                    >
                      <BsCircleFill size={10} color="#ff9800" />
                      <span
                        style={{
                          color: '#ff9800',
                          fontWeight: 600,
                          fontSize: '0.8rem',
                        }}
                      >
                        Interesse Social
                      </span>
                    </div>
                  )}

                  <div className="div-scroll mt-3">
                    {opcoesEmpreendimentos &&
                      opcoesEmpreendimentos
                        .slice(0, qtdEmpreendimentosExibidos)
                        .map((emp, index) => (
                          <div
                            key={emp.value.codigo_familia}
                            onClick={() => {
                              handleChangeVinculo(emp);
                            }}
                            className={`rounded hover-shadow hover-empreendimento p-1 ${
                              index === 0 && opcoesEmpreendimentos.length > 1
                                ? 'empreendimento-selecinado '
                                : ''
                            }`}
                            style={{
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                              border: '1px solid transparent',
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              height: '100%',
                              maxHeight: '100px',
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-center ">
                              <div>
                                <small
                                  className="text-muted"
                                  style={{
                                    fontFamily: 'Open Sans, sans-serif',
                                    fontSize: '0.7rem',
                                  }}
                                >
                                  #
                                  {emp.label.split('-')[0].trim() +
                                    ' - ' +
                                    format.datetime(emp.value.data_vinculo) ||
                                    'sem código'}
                                </small>
                              </div>

                              <div className="">
                                <div
                                  className="px-2 py-1"
                                  style={{
                                    fontFamily: 'Open Sans, sans-serif',
                                    fontSize: '0.6rem',
                                  }}
                                >
                                  <BsCircleFill
                                    className="mb-1"
                                    size={8}
                                    style={{
                                      color: emp.value.cor_etapa,
                                      marginRight: '5px',
                                      verticalAlign: 'middle',
                                    }}
                                  />
                                  {
                                    STATUS_ETAPAS_PROSPECTOS.find(
                                      x => x.codigo === emp.value.codigo_status
                                    ).descricao
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="">
                              <small
                                className="text-truncate mb-1"
                                style={{
                                  textAlign: 'left',
                                  fontFamily: 'Open Sans, sans-serif',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: 'block',
                                }}
                                title={
                                  emp.label.split('-')[1].trim() ||
                                  'sem empreendimento'
                                }
                              >
                                {emp.label.split('-')[1].trim() ||
                                  'sem empreendimento'}
                              </small>
                            </div>
                            <hr className="m-0 opacity-25"></hr>
                          </div>
                        ))}
                  </div>
                  <div>
                    {total > defaultToShow && (
                      <div className="d-flex justify-content-center">
                        <Button
                          variant="link"
                          size="sm"
                          onClick={handleToggleExpand}
                          style={{
                            color: '#2196f3',
                            fontWeight: 600,
                            textDecoration: 'underline',
                            padding: 0,
                            margin: 0,
                            background: 'none',
                          }}
                        >
                          {expandido
                            ? `Ver menos (${hiddenCount}) vínculos`
                            : `Ver mais (${hiddenCount}) vínculos`}
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="div-card">
                  <hr className="my-2" />
                  <div className="mb-2">
                    <span className="custom-span">Email</span>
                    <div className="fw-bold">
                      <label>{prospecto.email || 'Não informado'}</label>
                    </div>
                  </div>
                  <hr className="my-2" />
                  <div className="mb-2">
                    <span className="custom-span">Telefone</span>
                    <div className="d-flex justify-content-between">
                      <div className="fw-bold">
                        <label
                          style={{ cursor: 'pointer' }}
                          onMouseEnter={e => {
                            e.target.style.textDecoration = 'underline';
                          }}
                          onMouseLeave={e => {
                            e.target.style.textDecoration = '';
                          }}
                          onClick={() =>
                            copiarTexto(format.celular(prospecto.tel_celular))
                          }
                        >
                          {format.celular(prospecto.tel_celular) ||
                            'Não informado'}
                        </label>
                      </div>
                      {prospecto.tel_celular &&
                        prospecto.tel_celular.length > 10 && (
                          <a
                            href={`https://api.whatsapp.com/send?phone=55${prospecto.tel_celular}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              background: '#25d366',
                              borderRadius: 8,
                              padding: 8,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginLeft: 8,
                              textDecoration: 'none',
                            }}
                            title="Conversar no WhatsApp"
                          >
                            <IoLogoWhatsapp color="#fff" size={17} />
                          </a>
                        )}
                    </div>
                  </div>
                  <hr className="my-2" />
                  <div className="mb-2">
                    <span className="custom-span">CPF</span>
                    <div className="fw-bold">
                      <label
                        style={{ cursor: 'pointer' }}
                        onMouseEnter={e => {
                          e.target.style.textDecoration = 'underline';
                        }}
                        onMouseLeave={e => {
                          e.target.style.textDecoration = '';
                        }}
                        onClick={() => copiarTexto(format.cpf(prospecto.cpf))}
                      >
                        {format.cpf(prospecto.cpf) || 'Não informado'}
                      </label>
                    </div>
                  </div>
                  <hr className="my-2" />
                  <div className="mb-2">
                    <span className="custom-span">Empreendimento(s)</span>
                    <div className="fw-bold">
                      {(() => {
                        const temVinculoReal = prospecto.prospecto_empreendimento.some(
                          v => v.codigo_familia > 0
                        );
                        const vinculosFiltrados = temVinculoReal
                          ? prospecto.prospecto_empreendimento.filter(
                              v => v.codigo_familia > 0
                            )
                          : prospecto.prospecto_empreendimento;
                        return vinculosFiltrados.length > 0
                          ? vinculosFiltrados.map((emp, index) => (
                              <div key={index}>
                                <small>
                                  {emp.empreendimento.codigo} -{' '}
                                  {emp.empreendimento.descricao}
                                </small>
                              </div>
                            ))
                          : 'Não informado';
                      })()}
                    </div>
                  </div>

                  <hr className="my-2" />
                  <div>
                    <div className="d-flex justify-content-between">
                      <label
                        style={{
                          fontWeight: 700,
                          color: '#2D3A66',
                          fontFamily: "'Open Sans', Arial, sans-serif",
                          marginBottom: 4,
                        }}
                      >
                        Tags
                      </label>
                      <IconButton
                        onClick={() => {
                          setMostrarModalTag(true);
                        }}
                        title="Procurar tag"
                      >
                        <FaTag size={16} />
                      </IconButton>
                    </div>
                    <div
                      style={{
                        border: '1px solid #e0e0e0',
                        borderRadius: 8,
                        background: '#fff',
                        padding: 8,
                        minHeight: 44,
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: 6,
                      }}
                    >
                      {vinculoEmpreendimentoSelecionado &&
                        vinculoEmpreendimentoSelecionado.tags.length > 0 &&
                        vinculoEmpreendimentoSelecionado.tags.map(
                          (tag, idx) => (
                            <span
                              key={idx}
                              style={{
                                background: '#2196f3',
                                color: '#fff',
                                borderRadius: 13,
                                padding: '2px 12px',
                                fontSize: 14,
                                display: 'flex',
                                alignItems: 'center',
                                fontFamily: "'Open Sans', Arial, sans-serif",
                                marginRight: 2,
                                marginBottom: 2,
                                cursor: 'default',
                              }}
                            >
                              {tag.descricao}

                              <IconButton
                                size="small"
                                onClick={() => {
                                  removerTag(tag);
                                }}
                                title="Remover tag"
                                disabled={removendoTag}
                              >
                                <FaTimes
                                  className="ml-2"
                                  size={13}
                                  color="#fff"
                                />
                              </IconButton>
                            </span>
                          )
                        )}
                    </div>
                  </div>
                  <hr className="my-2" />
                  <div className="mb-2">
                    <span className="custom-span">Mídia Origem</span>
                    <div className="fw-bold">
                      {prospecto.midia_origem_prospecto || 'OUTRO'}
                    </div>
                  </div>
                  <hr className="my-2" />
                  <div className="mb-2">
                    <span className="custom-span">Tipo de Cadastro</span>
                    <div className="fw-bold">
                      {prospecto.descricao_origem_usuario_criacao ||
                        'Não Definido'}
                    </div>
                  </div>
                  <hr className="my-2" />
                  <div className="mb-2">
                    <span className="custom-span">Primeira Origem</span>
                    <div className="fw-bold">
                      {prospecto.descricao_origem_prospecto}
                    </div>
                  </div>

                  {prospecto.custom_fields_rd_station && (
                    <>
                      <hr className="my-2" />
                      <div className="mb-2">
                        <span
                          className="custom-span"
                          style={{
                            fontWeight: 700,
                            color: '#2D3A66',
                            fontFamily: "'Open Sans', Arial, sans-serif",
                          }}
                        >
                          Campos Adicionais
                        </span>
                        <div
                          style={{
                            marginTop: 8,
                            border: '1px solid #e0e0e0',
                            borderRadius: 8,
                            background: '#fafbfc',
                            padding: 12,
                          }}
                        >
                          {(() => {
                            try {
                              const customFields =
                                typeof prospecto.custom_fields_rd_station ===
                                'string'
                                  ? JSON.parse(
                                      prospecto.custom_fields_rd_station
                                    )
                                  : prospecto.custom_fields_rd_station;

                              const fields = Object.entries(customFields || {});

                              if (fields.length === 0) {
                                return (
                                  <div className="text-center text-muted py-2">
                                    <small>
                                      Nenhum campo adicional disponível
                                    </small>
                                  </div>
                                );
                              }

                              const truncarCampo = (value, maxLength) => {
                                if (
                                  typeof value === 'string' &&
                                  value.length > maxLength
                                ) {
                                  return value.substring(0, maxLength) + '...';
                                }
                                return value;
                              };

                              const copiarCampo = (valor) => {
                                const texto =
                                  valor == null ? '' : String(valor);
                                if (!texto) return;
                                const aposSucesso = () =>
                                  toast.success('Conteúdo copiado!');
                                if (
                                  navigator.clipboard &&
                                  navigator.clipboard.writeText
                                ) {
                                  navigator.clipboard
                                    .writeText(texto)
                                    .then(aposSucesso)
                                    .catch(() =>
                                      toast.error('Não foi possível copiar')
                                    );
                                } else {
                                  const textarea =
                                    document.createElement('textarea');
                                  textarea.value = texto;
                                  textarea.style.position = 'fixed';
                                  textarea.style.opacity = '0';
                                  document.body.appendChild(textarea);
                                  textarea.select();
                                  try {
                                    document.execCommand('copy');
                                    aposSucesso();
                                  } catch (e) {
                                    toast.error('Não foi possível copiar');
                                  }
                                  document.body.removeChild(textarea);
                                }
                              };

                              return fields.map(([key, value], idx) => {
                                const temValor =
                                  value != null && String(value).length > 0;
                                return (
                                  <div
                                    key={key}
                                    className="mb-2"
                                    style={{
                                      borderBottom:
                                        idx < fields.length - 1
                                          ? '1px solid #e9ecef'
                                          : 'none',
                                      paddingBottom:
                                        idx < fields.length - 1 ? 8 : 0,
                                    }}
                                  >
                                    <small
                                      className="text-muted d-block"
                                      style={{
                                        textTransform: 'capitalize',
                                        fontSize: '0.75rem',
                                      }}
                                    >
                                      {key.replace(/_/g, ' ')}
                                    </small>
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6,
                                      }}
                                    >
                                      <span
                                        className="fw-bold"
                                        style={{
                                          fontSize: '0.875rem',
                                          flex: 1,
                                          wordBreak: 'break-word',
                                        }}
                                      >
                                        {truncarCampo(value, 42) ||
                                          'Não informado'}
                                      </span>
                                      {temValor && (
                                        <button
                                          type="button"
                                          onClick={() => copiarCampo(value)}
                                          title="Copiar conteúdo"
                                          aria-label="Copiar conteúdo"
                                          style={{
                                            background: 'transparent',
                                            border: 'none',
                                            padding: 4,
                                            cursor: 'pointer',
                                            color: '#2D3A66',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0,
                                          }}
                                        >
                                          <FaRegCopy size={14} />
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                );
                              });
                            } catch (error) {
                              console.error(
                                'Erro ao processar campos adicionais:',
                                error
                              );
                              return (
                                <div className="text-center text-danger py-2">
                                  <small>
                                    Erro ao carregar campos adicionais
                                  </small>
                                </div>
                              );
                            }
                          })()}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={12} sm={12} lg={6} xl={6} className="mb-3">
            {!desabilitarFuncionalidades() && (
              <Card
                className="card-responsive mb-3"
                style={{ border: 'none', boxShadow: 'none' }}
              >
                <Card.Body className="p-0">
                  <div className="div-card">
                    <Form>
                      <h6 className="h6-acoes">O que deseja fazer? </h6>
                      <div
                        className="d-flex justify-content-between flex-wrap"
                        style={{ gap: '10px' }}
                      >
                        <Button
                          size="sm"
                          className={`custom-button-acoes ${
                            opcaoAdicional === 'anotacao' ? ' force-hover' : ''
                          }`}
                          title="Criar anotação"
                          onClick={() =>
                            setOpcaoAdicional(
                              opcaoAdicional === 'anotacao' ? null : 'anotacao'
                            )
                          }
                        >
                          <NotePencil size={18} />
                          Anotação
                        </Button>
                        {/* <Button
                        size="sm"
                        className={`custom-button-acoes ${
                          opcaoAdicional === 'ligacao' ? ' force-hover' : ''
                        }`}
                        title="Fazer ligação"
                        onClick={() =>
                          setOpcaoAdicional(
                            opcaoAdicional === 'ligacao' ? null : 'ligacao'
                          )
                        }
                      >
                        <PhoneCall size={18} />
                        Ligação
                      </Button> */}
                        <Button
                          size="sm"
                          className={`custom-button-acoes ${
                            opcaoAdicional === 'email' ? ' force-hover' : ''
                          }`}
                          title="Enviar e-mail"
                          onClick={() =>
                            setOpcaoAdicional(
                              opcaoAdicional === 'email' ? null : 'email'
                            )
                          }
                        >
                          <Envelope size={18} />
                          E-mail
                        </Button>
                        <Button
                          size="sm"
                          className={`custom-button-acoes ${
                            opcaoAdicional === 'tarefa' ? ' force-hover' : ''
                          }`}
                          title="Criar tarefa"
                          onClick={() =>
                            setOpcaoAdicional(
                              opcaoAdicional === 'tarefa' ? null : 'tarefa'
                            )
                          }
                        >
                          <Note size={18} />
                          Tarefa
                        </Button>
                        <Button
                          size="sm"
                          className={`custom-button-acoes ${
                            opcaoAdicional === 'sms' ? ' force-hover' : ''
                          }`}
                          style={{}}
                          title="Enviar SMS"
                          onClick={() =>
                            setOpcaoAdicional(
                              opcaoAdicional === 'sms' ? null : 'sms'
                            )
                          }
                        >
                          <DeviceMobile size={18} />
                          SMS
                        </Button>
                        <Button
                          size="sm"
                          className={`custom-button-acoes ${
                            opcaoAdicional === 'visita' ? ' force-hover' : ''
                          }`}
                          title="Agendar visita"
                          onClick={() =>
                            setOpcaoAdicional(
                              opcaoAdicional === 'visita' ? null : 'visita'
                            )
                          }
                        >
                          <CalendarCheck size={18} />
                          Visita
                        </Button>
                      </div>
                    </Form>
                    <div className="mt-3">
                      {opcaoAdicional &&
                        (() => {
                          switch (opcaoAdicional) {
                            case 'email':
                              return (
                                <ModalAtividade
                                  show={opcaoAdicional === 'email'}
                                  onHide={() => setOpcaoAdicional('')}
                                  titulo="Inserir Atividade - Email"
                                  salvando={salvandoDados}
                                  componente={
                                    <Email
                                      onSubmit={values =>
                                        salvarFormulario(
                                          values,
                                          TIPO_ATIVIDADE.EMAIL,
                                          false
                                        )
                                      }
                                      modoEdicao={false}
                                      initialValues={{
                                        mensagemPadrao: '',
                                        assunto: '',
                                        descricao: '',
                                        destinatario: prospecto.email,
                                      }}
                                      salvandoDados={salvandoDados}
                                      closeModal={() => {
                                        setOpcaoAdicional('');
                                      }}
                                      exibirBlocoTarefa={true}
                                    />
                                  }
                                />
                              );
                            case 'anotacao':
                              return (
                                <ModalAtividade
                                  show={opcaoAdicional === 'anotacao'}
                                  onHide={() => setOpcaoAdicional('')}
                                  titulo="Inserir Atividade - Anotação"
                                  salvando={salvandoDados}
                                  componente={
                                    <Anotacao
                                      onSubmit={values =>
                                        salvarFormulario(
                                          values,
                                          TIPO_ATIVIDADE.ANOTACAO,
                                          false
                                        )
                                      }
                                      initialValues={anotacaoValues}
                                      salvandoDados={salvandoDados}
                                      closeModal={() => {
                                        setOpcaoAdicional('');
                                      }}
                                      exibirBlocoTarefa={true}
                                      permitirAnexo={true}
                                    />
                                  }
                                />
                              );
                            case 'tarefa':
                              return (
                                <ModalAtividade
                                  show={opcaoAdicional === 'tarefa'}
                                  onHide={() => setOpcaoAdicional('')}
                                  titulo="Inserir Atividade - Tarefa"
                                  salvando={salvandoDados}
                                  componente={
                                    <FormularioTarefas
                                      onSubmit={values =>
                                        salvarFormulario(
                                          values,
                                          TIPO_ATIVIDADE.TAREFA,
                                          false
                                        )
                                      }
                                      initialValues={{
                                        descricao: '',
                                        data: '',
                                        prioridade: '',
                                        situacao: '',
                                        tipoResponsavel: '',
                                        responsavel: '',
                                        lembreteEmail: '',
                                        sincronizarCalendario:
                                          PROVEDOR_CALENDARIO_EXTERNO.NENHUM,
                                      }}
                                      salvandoDados={salvandoDados}
                                      closeModal={() => {
                                        setOpcaoAdicional('');
                                      }}
                                    />
                                  }
                                />
                              );
                            case 'sms':
                              return (
                                <ModalAtividade
                                  show={opcaoAdicional === 'sms'}
                                  onHide={() => setOpcaoAdicional('')}
                                  titulo="Inserir Atividade - SMS"
                                  salvando={salvandoDados}
                                  componente={
                                    <Anotacao
                                      onSubmit={values =>
                                        salvarFormulario(
                                          values,
                                          TIPO_ATIVIDADE.SMS,
                                          false
                                        )
                                      }
                                      initialValues={{
                                        ...smsValues,
                                        telefone: prospecto.tel_celular,
                                      }}
                                      salvandoDados={salvandoDados}
                                      closeModal={() => {
                                        setOpcaoAdicional('');
                                      }}
                                      exibirBlocoTarefa={true}
                                    />
                                  }
                                />
                              );
                            case 'visita':
                              return (
                                <ModalAtividade
                                  show={opcaoAdicional === 'visita'}
                                  onHide={() => setOpcaoAdicional('')}
                                  titulo="Inserir Atividade - Visita"
                                  salvando={salvandoDados}
                                  componente={
                                    <FormularioVisita
                                      onSubmit={values =>
                                        salvarFormulario(
                                          values,
                                          TIPO_ATIVIDADE.VISITA,
                                          false
                                        )
                                      }
                                      initialValues={{
                                        descricao: '',
                                        data: '',
                                        situacao: '',
                                        pdv: '',
                                        tipoResponsavel: '',
                                        responsavel: '',
                                        visitaVirtual: '',
                                        tipoVisita: '',
                                        recalcularVencimento: '',
                                        formasNotificacoes: '',
                                        sincronizarCalendario:
                                          PROVEDOR_CALENDARIO_EXTERNO.NENHUM,
                                      }}
                                      salvandoDados={salvandoDados}
                                      closeModal={() => {
                                        setOpcaoAdicional('');
                                      }}
                                    />
                                  }
                                />
                              );
                          }
                        })()}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            )}
            <Card
              //className="card-responsive mb-3"
              style={{ border: 'none', boxShadow: 'none' }}
            >
              <Card.Body className="lead-status-section">
                <div className="status-header">
                  <h6 className="h6-acoes">SITUAÇÃO DO LEAD</h6>
                </div>
                <div
                  className={`etapas-timeline ${
                    modoMobile ? 'mobile-view' : 'desktop-view'
                  }`}
                  style={{ maxWidth: '768px' }}
                  ref={el => {
                    if (el && vinculoEmpreendimentoSelecionado) {
                      const idx = STATUS_ETAPAS_PROSPECTOS.findIndex(
                        etapa =>
                          etapa.codigo ===
                          vinculoEmpreendimentoSelecionado.codigo_status
                      );
                      const current = el.children[idx];
                      if (current) {
                        current.scrollIntoView({
                          behavior: 'smooth',
                          inline: 'center',
                          block: 'nearest',
                        });
                      }
                    }
                  }}
                >
                  {STATUS_ETAPAS_PROSPECTOS.map((etapa, index) => {
                    const isCurrentEtapa =
                      etapa.codigo ===
                      (vinculoEmpreendimentoSelecionado
                        ? vinculoEmpreendimentoSelecionado.codigo_status
                        : null);
                    const isPastEtapa =
                      vinculoEmpreendimentoSelecionado &&
                      STATUS_ETAPAS_PROSPECTOS.findIndex(
                        e =>
                          e.codigo ===
                          vinculoEmpreendimentoSelecionado.codigo_status
                      ) > index;

                    return (
                      <>
                        {!modoMobile && (
                          <div key={index} className="etapa-wrapper">
                            {index > 0 && (
                              <div
                                className={`connector-line ${
                                  isPastEtapa ? 'completed' : ''
                                }`}
                              />
                            )}
                            <div
                              onClick={() => {
                                if (etapasPermitidas.includes(etapa.codigo)) {
                                  setMostrarModalTrocaEtapa(true);
                                  setDadosModalTrocaEtapa({
                                    etapaAtual:
                                      vinculoEmpreendimentoSelecionado.codigo_status,
                                    novaEtapa: etapa.codigo,
                                  });
                                }
                              }}
                              disabled={
                                etapasPermitidas
                                  ? !etapasPermitidas.includes(etapa.codigo)
                                  : false
                              }
                              style={{
                                cursor: etapasPermitidas
                                  ? !etapasPermitidas.includes(etapa.codigo)
                                    ? 'default'
                                    : undefined
                                  : undefined,
                              }}
                              className={`etapa-badge desktop-badge ${
                                isCurrentEtapa
                                  ? 'current'
                                  : isPastEtapa
                                  ? 'completed'
                                  : 'pending'
                              }`}
                              title={
                                isCurrentEtapa ? 'Etapa atual' : etapa.descricao
                              }
                            >
                              <span className="etapa-indicator">
                                {isPastEtapa
                                  ? '✓'
                                  : isCurrentEtapa
                                  ? '●'
                                  : index + 1}
                              </span>
                              <span className="etapa-text">
                                {etapa.descricao}
                              </span>
                            </div>
                          </div>
                        )}
                        {modoMobile && (
                          <div className="mt-3">
                            <div key={index} className="etapa-wrapper">
                              {index > 0 && (
                                <div
                                  className={`connector-line ${
                                    isPastEtapa ? 'completed' : ''
                                  }`}
                                />
                              )}
                              <div
                                onClick={() => {
                                  if (etapasPermitidas.includes(etapa.codigo)) {
                                    setMostrarModalTrocaEtapa(true);
                                    setDadosModalTrocaEtapa({
                                      etapaAtual:
                                        vinculoEmpreendimentoSelecionado.codigo_status,
                                      novaEtapa: etapa.codigo,
                                    });
                                  }
                                }}
                                disabled={
                                  etapasPermitidas
                                    ? !etapasPermitidas.includes(etapa.codigo)
                                    : false
                                }
                                style={{
                                  cursor: etapasPermitidas
                                    ? !etapasPermitidas.includes(etapa.codigo)
                                      ? 'default'
                                      : undefined
                                    : undefined,
                                }}
                                className={`etapa-badge desktop-badge ${
                                  isCurrentEtapa
                                    ? 'current'
                                    : isPastEtapa
                                    ? 'completed'
                                    : 'pending'
                                }`}
                                title={
                                  isCurrentEtapa
                                    ? 'Etapa atual'
                                    : etapa.descricao
                                }
                              >
                                <span className="etapa-indicator">
                                  {isPastEtapa
                                    ? '✓'
                                    : isCurrentEtapa
                                    ? '●'
                                    : index + 1}
                                </span>
                                <span className="etapa-text">
                                  {etapa.descricao}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    );
                  })}
                </div>
              </Card.Body>
            </Card>
            {!desabilitarFuncionalidades() && (
              <Card
                className="p-0 mt-2 mb-3"
                style={{ border: 'none', boxShadow: 'none' }}
              >
                <Card.Body className="lead-actions-section">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="h6-acoes">AÇÕES DO LEAD</div>
                  </div>
                  <div
                    className="acoes-prospecto-scroll"
                    style={{
                      display: 'flex',
                      flexFlow: 'row nowrap',
                      justifyContent: 'flex-start',
                      overflowX: 'auto',
                      overflowY: 'hidden',
                    }}
                  >
                    <Button
                      className="btn-custom-col3 mr-1"
                      size="sm"
                      onClick={() => {
                        toggleHistoricoProspecto();
                      }}
                    >
                      <Scroll size={18} className="mr-2" />
                      Histórico
                    </Button>
                    <Button
                      className="btn-custom-col3 mr-1"
                      size="sm"
                      variant={
                        prospecto.is_setclub
                          ? 'outline-danger'
                          : 'outline-success'
                      }
                      disabled={salvandoSetclub || !podeGerenciarSetclub}
                      title={
                        podeGerenciarSetclub
                          ? ''
                          : 'Usuario sem permissao para gerenciar SetClube'
                      }
                      onClick={alterarSetclubProspecto}
                    >
                      <FaStar size={18} className="mr-2" />
                      {prospecto.is_setclub
                        ? 'Remover SetClube'
                        : 'Adicionar SetClube'}
                    </Button>
                    {prospecto.cpf && (
                      <Button
                        className="btn-custom-col3 mr-1"
                        size="sm"
                        onClick={() => {
                          toggleExibirModalDadosJuridicos();
                        }}
                      >
                        <FaGavel size={18} className="mr-2" />
                        Jurídico
                      </Button>
                    )}
                    <Button
                      className="btn-custom-col3 mr-1"
                      size="sm"
                      onClick={abrirModalEventos}
                    >
                      <CalendarCheck size={18} className="mr-2" />
                      Eventos
                    </Button>
                    {AuthStorage.temCaracteristica(
                      caracteristicas.AtendenteCav
                    ) && (
                      <Button
                        className="btn-custom-col3 mr-1"
                        size="sm"
                        onClick={() => {
                          toggleModalUnificarProspecto();
                        }}
                      >
                        <FaCog size={18} className="mr-2" />
                        Unificar
                      </Button>
                    )}
                    {prospecto.cpf && (
                      <Button
                        className="btn-custom-col3 mr-1"
                        size="sm"
                        onClick={() => {
                          toggleModalSituacaoCliente();
                        }}
                      >
                        <FaClipboardCheck size={18} className="mr-2" />
                        Adimplência
                      </Button>
                    )}
                    {prospecto.cpf && podeMostrarModalAtualizarProspectoGES() && (
                      <Button
                        className="btn-custom-col3 mr-1"
                        size="sm"
                        onClick={() => {
                          toggleModalAtualizacao();
                        }}
                      >
                        <FaSync size={18} className="mr-2" />
                        Vínculo GES
                      </Button>
                    )}
                  </div>
                </Card.Body>
              </Card>
            )}
            <Card className="p-0" style={{ border: 'none', boxShadow: 'none' }}>
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="h6-acoes">ATIVIDADES DO LEAD</div>
                </div>
                <AtividadesTimeline
                  vinculoSelecionado={vinculoEmpreendimentoSelecionado}
                  editarAtividade={(atividade, tipo) => {
                    setAtividadeEditando(atividade);
                    setModalEdicaoTipo(tipo);
                  }}
                />
              </Card.Body>
            </Card>
          </Col>
          <Col md={12} sm={12} lg={3} xl={3}>
            <Card
              className="card-responsive"
              style={{ border: 'none', boxShadow: 'none' }}
            >
              <Card.Body className="p-0">
                <div className="div-card">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="h6-acoes mt-2">TAREFAS PENDENTES</div>
                  </div>
                  <div>
                    {vinculoEmpreendimentoSelecionado &&
                      vinculoEmpreendimentoSelecionado.atividades &&
                      vinculoEmpreendimentoSelecionado.atividades
                        .filter(item => item.etapa === 1 || item.etapa === 3)
                        .slice(0, qtdPendenciasExibidas)
                        .map(atividade => {
                          const atividadeDetalheObj = JSON.parse(
                            atividade.atividade
                          );
                          return (
                            <Card className="mt-1 h-25">
                              <Card.Body
                                className=""
                                style={{
                                  background: '#fafbfc',
                                  borderRadius: 8,
                                  padding: 8,
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  setAtividadeEditando(atividade);
                                  setModalEdicaoTipo(atividade.tipo_atividade);
                                  setQtdPendenciasExibidas(1);
                                }}
                              >
                                <div
                                  className="d-flex align-items-center "
                                  style={{ gap: 6 }}
                                >
                                  <div
                                    style={{
                                      minWidth: 60,
                                      textAlign: 'center',
                                      width: 80,
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontWeight: 600,
                                        fontSize: 16,
                                        color: '#757575',
                                      }}
                                    >
                                      {atividadeDetalheObj.data
                                        ? (() => {
                                            const data = new Date(
                                              atividadeDetalheObj.data
                                            );
                                            const dia = data
                                              .getDate()
                                              .toString()
                                              .padStart(2, '0');
                                            const meses = [
                                              'JAN',
                                              'FEV',
                                              'MAR',
                                              'ABR',
                                              'MAI',
                                              'JUN',
                                              'JUL',
                                              'AGO',
                                              'SET',
                                              'OUT',
                                              'NOV',
                                              'DEZ',
                                            ];
                                            const mes = meses[data.getMonth()];
                                            return `${dia} - ${mes}`;
                                          })()
                                        : '--'}
                                    </div>
                                    <div
                                      style={{
                                        background: '#bdbdbd',
                                        color: '#fff',
                                        borderRadius: 4,
                                        fontSize: 12,
                                        padding: '2px 8px',
                                        marginTop: 4,
                                        display: 'inline-block',
                                      }}
                                    >
                                      {atividade.descricao_tipo_atividade}
                                    </div>
                                  </div>
                                  <hr
                                    style={{
                                      width: '1px',
                                      height: '70px',
                                      backgroundColor: 'gray',
                                      border: 'none',
                                      margin: '0 6px',
                                    }}
                                  ></hr>
                                  <div style={{ flex: 1 }}>
                                    {atividadeDetalheObj.prioridade && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: 8,
                                            height: 8,
                                            borderRadius: '50%',
                                            background:
                                              atividadeDetalheObj.prioridade ===
                                              'Alta'
                                                ? '#ef3f56'
                                                : atividadeDetalheObj.prioridade ===
                                                  'Normal'
                                                ? '#fbc02d'
                                                : atividadeDetalheObj.prioridade ===
                                                  'Baixa'
                                                ? '#419aef'
                                                : '',
                                          }}
                                        ></div>
                                        <div>
                                          <small className="ml-1">
                                            {atividadeDetalheObj.prioridade}
                                          </small>
                                        </div>
                                      </div>
                                    )}

                                    {atividade.atividade_vinculada &&
                                      atividade.atividade_vinculada
                                        .codigo_atividade > 0 && (
                                        <div
                                          className="mb-1"
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <div
                                            style={{
                                              width: 6,
                                              height: 6,
                                              borderRadius: '50%',
                                              background: '#ef3f56',
                                            }}
                                          ></div>
                                          <div
                                            style={{
                                              fontSize: 12,
                                              color: '#757575',
                                            }}
                                          >
                                            <small className="text-dark ml-1">
                                              Possui
                                              {' ' +
                                                getTipoAtividadeTexto(
                                                  atividade.atividade_vinculada
                                                    .tipo_atividade
                                                )}
                                            </small>
                                          </div>
                                        </div>
                                      )}

                                    <div
                                      className=""
                                      style={{ fontSize: 12, color: '#757575' }}
                                    >
                                      <span className="text-dark">
                                        Responsável:{' '}
                                      </span>
                                      {atividadeDetalheObj.responsavel}
                                    </div>
                                    <div
                                      style={{ fontSize: 12, color: '#757575' }}
                                      className="mt-1"
                                    >
                                      <span className="text-dark">
                                        Descrição:{' '}
                                      </span>
                                      {atividadeDetalheObj.descricao}
                                    </div>
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          );
                        })}
                  </div>
                  <div>
                    {vinculoEmpreendimentoSelecionado &&
                      vinculoEmpreendimentoSelecionado.atividades.filter(
                        item => item.etapa === 1
                      ).length > 1 &&
                      qtdPendenciasExibidas <= 1 && (
                        <div className="d-flex justify-content-center">
                          <Button
                            variant="link"
                            size="sm"
                            style={{
                              color: '#2196f3',
                              fontWeight: 600,
                              textDecoration: 'underline',
                              boxShadow: 'none',
                              padding: 0,
                              margin: 0,
                              background: 'none',
                            }}
                            onClick={() => {
                              setQtdPendenciasExibidas(
                                vinculoEmpreendimentoSelecionado
                                  ? vinculoEmpreendimentoSelecionado.atividades
                                    ? vinculoEmpreendimentoSelecionado
                                        .atividades.length
                                    : 0
                                  : 0
                              );
                            }}
                          >
                            Ver mais
                          </Button>
                        </div>
                      )}
                  </div>
                </div>
              </Card.Body>
            </Card>
            {!AuthStorage.isCorretor() && !AuthStorage.isGerente() && (
              <Card
                className="card-responsive"
                style={{ border: 'none', boxShadow: 'none' }}
              >
                <Card.Body className="p-0">
                  <div className="div-card">
                    <div className="h6-acoes mb-2">QUEM ESTÁ ATENDENDO</div>
                    {renderDadosVinculo(vinculoEmpreendimentoSelecionado)}
                    {vinculoEmpreendimentoSelecionado && (
                      <div className="d-flex justify-content-end">
                        <Button
                          className="btn-custom-col3"
                          size="sm"
                          disabled={!AuthStorage.temCaracteristica(577)}
                          onClick={abrirModalTrocarResponsavel}
                        >
                          <ArrowsClockwise size={18} className="mr-2" />
                          Trocar responsável
                        </Button>
                      </div>
                    )}
                  </div>
                </Card.Body>
              </Card>
            )}
          </Col>
          {mostrarModalTrocaEtapa && (
            <Modal
              backdrop="static"
              size="md"
              centered
              show={mostrarModalTrocaEtapa}
              onHide={() => {
                fecharModalAtualizarEtapa();
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {dadosModalTrocaEtapa &&
                  dadosModalTrocaEtapa.novaEtapa ===
                    PROSPECTO_STATUS_ENUM.descartado
                    ? 'Descartar Vínculo'
                    : 'Mudança de etapa'}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {dadosModalTrocaEtapa &&
                  dadosModalTrocaEtapa.novaEtapa !==
                    PROSPECTO_STATUS_ENUM.descartado && (
                    <p className="open-sans">
                      Você está prestes a mover o prospecto{' '}
                      <strong>"{prospecto.nome}"</strong> de{' '}
                      <strong>
                        {
                          STATUS_ETAPAS_PROSPECTOS.filter(
                            e => e.codigo === dadosModalTrocaEtapa.etapaAtual
                          ).at(0).descricao
                        }
                      </strong>{' '}
                      para{' '}
                      <strong>
                        {
                          STATUS_ETAPAS_PROSPECTOS.filter(
                            e => e.codigo === dadosModalTrocaEtapa.novaEtapa
                          ).at(0).descricao
                        }
                      </strong>
                      . Deseja continuar?
                    </p>
                  )}
                {dadosModalTrocaEtapa &&
                  dadosModalTrocaEtapa.novaEtapa ===
                    PROSPECTO_STATUS_ENUM.descartado && (
                    <div className="w-100 px-3 pb-3">
                      <Form.Group>
                        <Form.Label>
                          Escolha um motivo para realizar o descarte deste
                          vínculo com o empreendimento
                        </Form.Label>
                        <Form.Control
                          as="select"
                          name="CodigoMotivo"
                          disabled={atualizandoEtapa}
                          value={motivoDescarte || ''}
                          onChange={e =>
                            selecionarMotivoDescarte(e.target.value)
                          }
                        >
                          <option value="">Selecione um motivo</option>
                          {options.motivosDescarte &&
                            options.motivosDescarte.map((item, index) => (
                              <option key={index} value={item.codigo}>
                                {item.descricao}
                              </option>
                            ))}
                        </Form.Control>
                        <Form.Text className="text-muted">
                          Justifique o motivo do descarte
                        </Form.Text>

                        <Form.Control
                          type="text"
                          className="mt-2"
                          value={dissertativaDescarte}
                          onChange={e =>
                            handleDissertativaDescarteChange(e.target.value)
                          }
                          placeholder="Justificativa (opcional)"
                        />
                      </Form.Group>
                    </div>
                  )}
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between">
                <div>
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      fecharModalAtualizarEtapa();
                    }}
                  >
                    Cancelar
                  </button>
                </div>
                <div>
                  {dadosModalTrocaEtapa &&
                  dadosModalTrocaEtapa.novaEtapa ===
                    PROSPECTO_STATUS_ENUM.descartado ? (
                    <button
                      type="button"
                      disabled={
                        atualizandoEtapa || !motivoDescarte || !podeDescartar
                      }
                      className="btn btn-sm btn-outline-danger"
                      onClick={async () => {
                        if (!podeDescartar) {
                          toast.error('Você não tem permissão para descartar.');
                          return;
                        }
                        try {
                          await atualizarEtapaProspecto({
                            codigo_prospecto: prospecto.codigo,
                            codigo_familia:
                              vinculoEmpreendimentoSelecionado.codigo_familia,
                            etapa_atual: dadosModalTrocaEtapa.etapaAtual,
                            nova_etapa: PROSPECTO_STATUS_ENUM.descartado,
                            codigo_motivo_descarte: motivoDescarte,
                            justificativa: dissertativaDescarte,
                          });
                          toast.success(
                            'Empreendimento descartado com sucesso.'
                          );
                        } catch (error) {
                          toast.error('Erro ao descartar empreendimento.');
                        }
                      }}
                    >
                      {atualizandoEtapa ? 'Processando...' : 'Descartar'}
                    </button>
                  ) : (
                    <Button
                      onClick={() => {
                        atualizarEtapaProspecto({
                          codigo_prospecto: prospecto.codigo,
                          codigo_familia:
                            vinculoEmpreendimentoSelecionado.codigo_familia,
                          etapa_atual: dadosModalTrocaEtapa.etapaAtual,
                          nova_etapa: dadosModalTrocaEtapa.novaEtapa,
                        });
                      }}
                      type="button"
                      variant={'outline-primary'}
                      className="active"
                      style={{
                        background: '#419AEF',
                        borderColor: '#419AEF',
                        fontFamily: 'Open Sans, Arial, sans-serif',
                      }}
                      disabled={atualizandoEtapa}
                    >
                      Confirmar
                    </Button>
                  )}
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {mostrarModalPerfilSetclube && (
            <Modal
              centered
              backdrop="static"
              show={mostrarModalPerfilSetclube}
              onHide={() => {
                setMostrarModalPerfilSetclube(false);
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Atualizar perfil para SetClube</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p className="mb-2">
                  SetClube é permitido somente para prospectos com perfil
                  Construtor ou Investidor.
                </p>
                <p className="mb-3">
                  Para seguir, selecione o perfil comprador que será gravado no
                  cadastro antes de marcar o prospecto como SetClube.
                </p>
                <Form.Group className="mb-0" controlId="perfilSetclube">
                  <Form.Label>Perfil comprador</Form.Label>
                  <Form.Control
                    as="select"
                    value={perfilSetclubeSelecionado}
                    disabled={salvandoSetclub}
                    onChange={event => {
                      setPerfilSetclubeSelecionado(
                        parseInt(event.target.value, 10)
                      );
                    }}
                  >
                    <option value={PERFIL_COMPRADOR_CONSTRUTOR}>
                      Construtor
                    </option>
                    <option value={PERFIL_COMPRADOR_INVESTIDOR}>
                      Investidor
                    </option>
                  </Form.Control>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="outline-secondary"
                  disabled={salvandoSetclub}
                  onClick={() => {
                    setMostrarModalPerfilSetclube(false);
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  variant="primary"
                  disabled={salvandoSetclub}
                  onClick={confirmarAtualizacaoPerfilSetclube}
                >
                  {salvandoSetclub
                    ? 'Atualizando...'
                    : 'Atualizar e marcar SetClube'}
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {editarProspecto && (
            <Modal
              size="xl"
              backdrop="static"
              show={editarProspecto}
              onHide={() => {
                fecharModalProspecto();
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Editar Prospecto </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ProspectoDetalhes
                  hiddenNavbar={true}
                  hiddenSearch={true}
                  showCancel={true}
                  prospectoID={codigoProspectoURL}
                  onCancel={() => {
                    fecharModalProspecto();
                  }}
                />
              </Modal.Body>
            </Modal>
          )}
          {exibirHistoricoProspecto && (
            <Modal
              size="xl"
              backdrop="static"
              show={exibirHistoricoProspecto}
              onHide={() => {
                toggleHistoricoProspecto();
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Histórico do Prospecto -{' '}
                  {vinculoEmpreendimentoSelecionado.empreendimento.descricao}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <HistoricoProspecto
                  codigoFamilia={
                    vinculoEmpreendimentoSelecionado.codigo_familia
                  }
                  codigoProspecto={
                    vinculoEmpreendimentoSelecionado.codigo_prospecto
                  }
                  historicoFluxo={
                    vinculoEmpreendimentoSelecionado.prospecto_empreendimento_historicos
                  }
                  cpfProspecto={prospecto.cpf}
                  codigoConta={vinculoEmpreendimentoSelecionado.codigo_conta}
                  ge={vinculoEmpreendimentoSelecionado.codigo_grupo_empresa}
                  empreendimentos={
                    prospecto.prospecto_empreendimento.some(
                      v => v.codigo_familia > 0
                    )
                      ? prospecto.prospecto_empreendimento.filter(
                          v => v.codigo_familia > 0
                        )
                      : prospecto.prospecto_empreendimento
                  }
                />
              </Modal.Body>
            </Modal>
          )}
          {exibirModalDadosJuridicos && (
            <Modal
              size="xl"
              backdrop="static"
              show={exibirModalDadosJuridicos}
              onHide={() => {
                toggleExibirModalDadosJuridicos();
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Dados Jurídicos</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <InformacoesJuridicas cpf={prospecto.cpf} />
              </Modal.Body>
            </Modal>
          )}
          {mostrarModalTag && (
            <Modal
              size="md"
              backdrop="static"
              show={mostrarModalTag}
              onHide={() => {
                setMostrarModalTag(false);
                setNovaTag(null);
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Adicionar Tag</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!salvandoNovaTag && !criandoTag && (
                  <div>
                    <div className="mb-3">
                      <label>Procurar Tag</label>
                      <CreatableSelect
                        placeholder={null}
                        formatCreateLabel={inputValue =>
                          `Criar tag "${inputValue}"`
                        }
                        loadingMessage={() => 'Procurando tags...'}
                        loadOptions={buscarTagsAutocomplete}
                        onInputChange={value => setCriarTag(value)}
                        onChange={option => setNovaTag(option)}
                        onCreateOption={criarEVincularTagAutocomplete}
                        value={novaTag}
                        noOptionsMessage={() => 'Tag não encontrada.'}
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                        isClearable
                      />
                    </div>
                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        variant="primary"
                        disabled={!novaTag}
                        onClick={() => {
                          vincularNovaTag(novaTag);
                          setNovaTag(null);
                        }}
                      >
                        Salvar
                      </Button>
                    </div>
                  </div>
                )}
                {(salvandoNovaTag || criandoTag) && (
                  <div>
                    <Loading
                      label={
                        salvandoNovaTag
                          ? 'Vinculando tag ao prospecto...'
                          : 'Criando nova tag...'
                      }
                    />
                  </div>
                )}
              </Modal.Body>
            </Modal>
          )}

          {mostrarModalSituacaoCliente && (
            <Modal
              size="xl"
              backdrop="static"
              show={mostrarModalSituacaoCliente}
              onHide={() => {
                setMostrarModalSituacaoCliente(false);
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Detalhe Adimplência</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <CardSituacaoDetalhada cpf={prospecto.cpf || ''} />
              </Modal.Body>
            </Modal>
          )}

          {mostrarModalUnificar && (
            <ModalUnificar
              prospecto={prospecto}
              setProspecto={setProspecto}
              mostrarModalUnificar={mostrarModalUnificar}
              setMostrarModalUnificar={setMostrarModalUnificar}
            />
          )}
          {modalEdicaoTipo &&
            (() => {
              switch (modalEdicaoTipo) {
                case TIPO_ATIVIDADE.TAREFA:
                  return (
                    <ModalAtividade
                      show={atividadeEditando}
                      onHide={() => {
                        setModalEdicaoTipo(null);
                        setAtividadeEditando(null);
                      }}
                      titulo="Editar Atividade - Tarefa"
                      salvando={salvandoDados}
                      componente={
                        <FormularioTarefas
                          onSubmit={values =>
                            salvarFormulario(
                              values,
                              TIPO_ATIVIDADE.TAREFA,
                              true
                            )
                          }
                          initialValues={{
                            ...JSON.parse(atividadeEditando.atividade),
                            codigoAtividade: atividadeEditando.codigo_atividade,
                          }}
                          modoEdicao={true}
                          closeModal={() => {
                            setModalEdicaoTipo(null);
                            setAtividadeEditando(null);
                          }}
                          atividadeVinculada={
                            atividadeEditando.atividade_vinculada || ''
                          }
                        />
                      }
                    />
                  );
                case TIPO_ATIVIDADE.VISITA:
                  return (
                    <ModalAtividade
                      show={!!atividadeEditando}
                      onHide={() => {
                        setModalEdicaoTipo(null);
                        setAtividadeEditando(null);
                      }}
                      titulo="Editar Atividade - Visita"
                      salvando={salvandoDados}
                      componente={
                        <FormularioVisita
                          onSubmit={values =>
                            salvarFormulario(
                              values,
                              TIPO_ATIVIDADE.VISITA,
                              true
                            )
                          }
                          initialValues={{
                            ...JSON.parse(atividadeEditando.atividade),
                            codigoAtividade: atividadeEditando.codigo_atividade,
                          }}
                          modoEdicao={true}
                          closeModal={() => {
                            setModalEdicaoTipo(null);
                            setAtividadeEditando(null);
                          }}
                        />
                      }
                    />
                  );
                case TIPO_ATIVIDADE.ANOTACAO:
                  return (
                    <ModalAtividade
                      show={!!atividadeEditando}
                      onHide={() => {
                        setModalEdicaoTipo(null);
                        setAtividadeEditando(null);
                      }}
                      titulo="Editar Atividade - Anotação"
                      salvando={salvandoDados}
                      componente={
                        <Anotacao
                          onSubmit={values =>
                            salvarFormulario(
                              values,
                              TIPO_ATIVIDADE.ANOTACAO,
                              true
                            )
                          }
                          initialValues={{
                            descricao: JSON.parse(atividadeEditando.atividade)
                              .descricao,
                            codigoAtividade: atividadeEditando.codigo_atividade,
                          }}
                          salvandoDados={salvandoDados}
                          closeModal={() => {
                            setModalEdicaoTipo(null);
                            setAtividadeEditando(null);
                          }}
                          exibirBlocoTarefa={false}
                          permitirAnexo={false}
                        />
                      }
                    />
                  );
              }
            })()}
        </Row>
      )}
      {prospecto === null && (
        <div className="loading-container">
          <Loading label="Carregando dados do prospecto..." />
        </div>
      )}

      <Modal
        show={mostrarModalTrocarResponsavel}
        onHide={fecharModalTrocarResponsavel}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <ArrowsClockwise size={20} className="mr-2" />
            Atribuir Responsável
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(() => {
            const corretorJaAtivo = obterCorretorGerenteAtivoDoLead();
            if (!corretorJaAtivo) return null;
            return (
              <div className="alert alert-info mb-3">
                Este lead já é atendido pelo corretor{' '}
                <strong>{corretorJaAtivo.nome_corretor || 'já vinculado'}</strong>
                {corretorJaAtivo.nome_gerente ? ' (gerente ' : ''}
                {corretorJaAtivo.nome_gerente && (
                  <strong>{corretorJaAtivo.nome_gerente}</strong>
                )}
                {corretorJaAtivo.nome_gerente ? ')' : ''}. A atribuição direta
                foi sugerida automaticamente para manter a continuidade do
                atendimento.
              </div>
            );
          })()}
          <div className="mb-4">
            <h6 className="mb-3">TIPO DE ATRIBUIÇÃO</h6>

            <div
              className="atribuicao-option mb-3 p-3 border rounded"
              style={{
                backgroundColor:
                  tipoAtribuicao === 'fila' ? '#f8f9ff' : '#f8f9fa',
                borderColor: tipoAtribuicao === 'fila' ? '#6f42c1' : '#e0e0e0',
                cursor: 'pointer',
              }}
              onClick={() => setTipoAtribuicao('fila')}
            >
              <div className="d-flex align-items-center">
                <Form.Check
                  type="radio"
                  name="tipoAtribuicao"
                  checked={tipoAtribuicao === 'fila'}
                  onChange={() => setTipoAtribuicao('fila')}
                  className="mr-3"
                />
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center mb-1">
                    <strong>Adicionar a uma fila</strong>
                    {!obterCorretorGerenteAtivoDoLead() && (
                      <span
                        className="badge badge-success ml-2"
                        style={{ fontSize: '0.7rem' }}
                      >
                        RECOMENDADO
                      </span>
                    )}
                  </div>
                  <small className="text-muted">
                    Sistema distribui automaticamente baseado em regras e
                    performance
                  </small>
                </div>
              </div>
            </div>

            <div
              className="atribuicao-option mb-3 p-3 border rounded"
              style={{
                backgroundColor:
                  tipoAtribuicao === 'corretor' ? '#f8f9ff' : '#f8f9fa',
                borderColor:
                  tipoAtribuicao === 'corretor' ? '#6f42c1' : '#e0e0e0',
                cursor: 'pointer',
              }}
              onClick={() => setTipoAtribuicao('corretor')}
            >
              <div className="d-flex align-items-center">
                <Form.Check
                  type="radio"
                  name="tipoAtribuicao"
                  checked={tipoAtribuicao === 'corretor'}
                  onChange={() => setTipoAtribuicao('corretor')}
                  className="mr-3"
                />
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center mb-1">
                    <strong>Atribuir Corretor Diretamente</strong>
                    {obterCorretorGerenteAtivoDoLead() && (
                      <span
                        className="badge badge-success ml-2"
                        style={{ fontSize: '0.7rem' }}
                      >
                        RECOMENDADO
                      </span>
                    )}
                  </div>
                  <small className="text-muted">
                    Selecione manualmente um corretor específico (ignora filas)
                  </small>
                </div>
              </div>
            </div>

            <div
              className="atribuicao-option mb-3 p-3 border rounded"
              style={{
                backgroundColor:
                  tipoAtribuicao === 'gestor' ? '#f8f9ff' : '#f8f9fa',
                borderColor:
                  tipoAtribuicao === 'gestor' ? '#6f42c1' : '#e0e0e0',
                cursor: 'pointer',
              }}
              onClick={() => setTipoAtribuicao('gestor')}
            >
              <div className="d-flex align-items-center">
                <Form.Check
                  type="radio"
                  name="tipoAtribuicao"
                  checked={tipoAtribuicao === 'gestor'}
                  onChange={() => setTipoAtribuicao('gestor')}
                  className="mr-3"
                />
                <div className="flex-grow-1">
                  <div className="mb-1">
                    <strong>Atribuir para Atendente</strong>
                  </div>
                  <small className="text-muted">
                    Encaminhar para qualificação prévia antes do corretor
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4">
            {tipoAtribuicao === 'fila' && (
              <div>
                <Form.Group>
                  <Form.Label>
                    Selecionar Fila <span className="text-danger">*</span>
                  </Form.Label>
                  {carregandoEscalas ? (
                    <div className="text-center py-3">
                      <div
                        className="spinner-border spinner-border-sm text-primary"
                        role="status"
                      >
                        <span className="sr-only">Carregando...</span>
                      </div>
                      <span className="ml-2 text-muted">
                        Carregando filas...
                      </span>
                    </div>
                  ) : (
                    <Select
                      options={escalasDisponiveis}
                      value={escalaSelecionada}
                      onChange={setEscalaSelecionada}
                      placeholder="Escolha uma fila..."
                      isClearable
                      isSearchable
                      styles={customStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      noOptionsMessage={() => 'Nenhuma fila encontrada'}
                    />
                  )}
                  {escalasDisponiveis.length === 0 && !carregandoEscalas && (
                    <div className="alert alert-warning mt-2">
                      <i className="fas fa-exclamation-triangle mr-2"></i>
                      Nenhuma fila disponível para este empreendimento.
                    </div>
                  )}
                </Form.Group>
              </div>
            )}

            {tipoAtribuicao === 'corretor' && (
              <div>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Gerentes <span className="text-danger">*</span>
                  </Form.Label>
                  <Select
                    options={gerentesFormatados}
                    value={gerenteSelecionado}
                    onChange={selectedGerente => {
                      setGerenteSelecionado(selectedGerente);
                      setCorretorSelecionado(null);
                    }}
                    placeholder="Selecione um gerente..."
                    isClearable
                    isSearchable
                    styles={customStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    noOptionsMessage={() => 'Nenhum gerente encontrado'}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Label>
                    Adicionar a um corretor{' '}
                    <span className="text-danger">*</span>
                  </Form.Label>
                  {carregandoCorretores ? (
                    <div className="text-center py-3">
                      <div
                        className="spinner-border spinner-border-sm text-primary"
                        role="status"
                      >
                        <span className="sr-only">Carregando...</span>
                      </div>
                      <span className="ml-2 text-muted">
                        Carregando corretores...
                      </span>
                    </div>
                  ) : (
                    <Select
                      options={
                        gerenteSelecionado
                          ? filtrarCorretoresPorGerente(gerenteSelecionado)
                          : []
                      }
                      value={corretorSelecionado}
                      onChange={setCorretorSelecionado}
                      placeholder={
                        gerenteSelecionado
                          ? 'Escolha um corretor...'
                          : 'Selecione um gerente primeiro'
                      }
                      isClearable
                      isSearchable
                      isDisabled={!gerenteSelecionado}
                      styles={customStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      noOptionsMessage={() => 'Nenhum corretor encontrado'}
                    />
                  )}
                </Form.Group>
              </div>
            )}

            {tipoAtribuicao === 'gestor' && (
              <div>
                <Form.Group>
                  <Form.Label>
                    Selecionar Atendente <span className="text-danger">*</span>
                  </Form.Label>
                  {carregandoGestores ? (
                    <div className="text-center py-3">
                      <div
                        className="spinner-border spinner-border-sm text-primary"
                        role="status"
                      >
                        <span className="sr-only">Carregando...</span>
                      </div>
                      <span className="ml-2 text-muted">
                        Carregando atendentes...
                      </span>
                    </div>
                  ) : (
                    <Select
                      options={gestoresDisponiveis}
                      value={gestorSelecionado}
                      onChange={setGestorSelecionado}
                      placeholder="Escolha um atendente..."
                      isClearable
                      isSearchable
                      styles={customStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      noOptionsMessage={() => 'Nenhum atendente encontrado'}
                    />
                  )}
                  {gestoresDisponiveis.length === 0 && !carregandoGestores && (
                    <div className="alert alert-warning mt-2">
                      <i className="fas fa-exclamation-triangle mr-2"></i>
                      Nenhum atendente disponível para este empreendimento.
                    </div>
                  )}
                </Form.Group>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={fecharModalTrocarResponsavel}
            disabled={atribuindoResponsavel}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={atribuirNovoResponsavel}
            disabled={
              atribuindoResponsavel ||
              (tipoAtribuicao === 'fila' &&
                (!escalaSelecionada || carregandoEscalas)) ||
              (tipoAtribuicao === 'corretor' &&
                (!gerenteSelecionado ||
                  !corretorSelecionado ||
                  carregandoCorretores)) ||
              (tipoAtribuicao === 'gestor' &&
                (!gestorSelecionado || carregandoGestores))
            }
          >
            {atribuindoResponsavel ? (
              <>
                <span
                  className="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Confirmando Atribuição
              </>
            ) : (
              'Confirmar Atribuição'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      {exibirModalEventos && (
        <Modal
          size="lg"
          backdrop="static"
          show={exibirModalEventos}
          onHide={fecharModalEventos}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <CalendarCheck size={20} className="mr-2" />
              Eventos Disponíveis
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="p-3">
              <Form.Group>
                <Form.Label>
                  Selecionar Evento <span className="text-danger">*</span>
                </Form.Label>
                {carregandoEventos ? (
                  <div className="text-center py-3">
                    <div
                      className="spinner-border spinner-border-sm text-primary"
                      role="status"
                    >
                      <span className="sr-only">Carregando...</span>
                    </div>
                    <span className="ml-2 text-muted">
                      Carregando eventos...
                    </span>
                  </div>
                ) : (
                  <Select
                    options={eventosDisponiveis}
                    value={eventoSelecionado}
                    onChange={setEventoSelecionado}
                    placeholder="Escolha um evento..."
                    isClearable
                    isSearchable
                    styles={customStyles}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    noOptionsMessage={() => 'Nenhum evento encontrado'}
                  />
                )}
                {eventosDisponiveis.length === 0 && !carregandoEventos && (
                  <div className="alert alert-warning mt-3">
                    <i className="fas fa-exclamation-triangle mr-2"></i>
                    Nenhum evento disponível no momento.
                  </div>
                )}
              </Form.Group>

              {eventoSelecionado && (
                <div className="border rounded p-3 bg-light mt-3">
                  <h6 className="mb-3">Detalhes do Evento</h6>

                  <div className="mb-3">
                    <small className="text-muted d-block mb-1">
                      Nome do Evento
                    </small>
                    <strong>{eventoSelecionado.label}</strong>
                  </div>

                  <div className="mb-3">
                    <small className="text-muted d-block mb-1">
                      Empreendimento
                    </small>
                    <strong>
                      {eventoSelecionado.codigo_familia} -{' '}
                      {eventoSelecionado.nome_familia}
                    </strong>
                  </div>

                  <div className="mb-3">
                    <small className="text-muted d-block mb-1">
                      Tag Associada
                    </small>
                    <span
                      style={{
                        background: '#2196f3',
                        color: '#fff',
                        borderRadius: 13,
                        padding: '4px 12px',
                        fontSize: 14,
                        display: 'inline-block',
                        fontFamily: "'Open Sans', Arial, sans-serif",
                      }}
                    >
                      {eventoSelecionado.nome_tag}
                    </span>
                  </div>

                  <div className="mb-3">
                    <small className="text-muted d-block mb-1">
                      Período do Evento
                    </small>
                    <div className="d-flex align-items-center">
                      <CalendarCheck size={16} className="mr-2 text-primary" />
                      <strong>
                        {format.date(
                          eventoSelecionado.data_inicial,
                          'DD/MM/YYYY'
                        )}{' '}
                        até{' '}
                        {format.date(
                          eventoSelecionado.data_final,
                          'DD/MM/YYYY'
                        )}
                      </strong>
                    </div>
                  </div>

                  <div className="mb-2">
                    <small className="text-muted d-block mb-1">Status</small>
                    <span
                      className={`badge ${
                        eventoSelecionado.ativo
                          ? 'badge-success'
                          : 'badge-secondary'
                      }`}
                    >
                      {eventoSelecionado.ativo ? 'Ativo' : 'Inativo'}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={fecharModalEventos}>
              Cancelar
            </Button>
            <Button
              variant="primary"
              disabled={!eventoSelecionado || salvandoDados}
              onClick={async () => {
                setSalvandoDados(true);
                await vincularNovaTag({
                  value: eventoSelecionado.codigo_tag,
                  label: eventoSelecionado.nome_tag,
                });
                setSalvandoDados(false);
                fecharModalEventos();
              }}
            >
              Confirmar
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {exibirModalEventosTag && eventosTag && (
        <Modal
          size="md"
          backdrop="static"
          show={exibirModalEventosTag}
          onHide={() => setExibirModalEventosTag(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <FaTag className="mr-2" />
              Tag Evento de Disponível
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="p-3">
              <div className="mb-3">
                <h3 className="text-primary mb-3">{eventosTag.nome_evento}</h3>
              </div>

              <div className="border rounded p-3 bg-light">
                <div className="mb-3">
                  <small className="text-muted d-block mb-1">
                    Empreendimento
                  </small>
                  <strong>
                    {eventosTag.codigo_familia} - {eventosTag.nome_familia}
                  </strong>
                </div>

                <div className="mb-3">
                  <small className="text-muted d-block mb-1">Tag</small>
                  <span
                    style={{
                      background: '#2196f3',
                      color: '#fff',
                      borderRadius: 13,
                      padding: '4px 12px',
                      fontSize: 14,
                      display: 'inline-block',
                      fontFamily: "'Open Sans', Arial, sans-serif",
                    }}
                  >
                    {eventosTag.nome_tag}
                  </span>
                </div>

                <div className="mb-3">
                  <small className="text-muted d-block mb-1">
                    Período do Evento
                  </small>
                  <div className="d-flex align-items-center">
                    <CalendarCheck size={16} className="mr-2 text-primary" />
                    <strong>
                      {format.date(eventosTag.data_inicial, 'DD/MM/YYYY')} até{' '}
                      {format.date(eventosTag.data_final, 'DD/MM/YYYY')}
                    </strong>
                  </div>
                </div>

                <div className="mb-2">
                  <small className="text-muted d-block mb-1">Status</small>
                  <span
                    className={`badge ${
                      eventosTag.ativo ? 'badge-success' : 'badge-secondary'
                    }`}
                  >
                    {eventosTag.ativo ? 'Ativo' : 'Inativo'}
                  </span>
                </div>
              </div>

              <div className="alert alert-info mt-3 mb-0">
                <label>
                  Deseja adicionar esta tag ao prospecto para participar do
                  evento?
                </label>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <Button
              variant="secondary"
              onClick={() => setExibirModalEventosTag(false)}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                vincularNovaTag({
                  value: eventosTag.codigo_tag,
                  label: eventosTag.nome_tag,
                });
                setExibirModalEventosTag(false);
              }}
              disabled={salvandoNovaTag}
            >
              {salvandoNovaTag ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm mr-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Adicionando...
                </>
              ) : (
                <>
                  <FaTag className="mr-2" />
                  Adicionar Tag
                </>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {mostrarModalAtualizacao && (
        <ModalAtualizacao
          vinculoSelecionado={vinculoEmpreendimentoSelecionado}
          mostrarModal={mostrarModalAtualizacao}
          setMostrarModalAtualizacao={setMostrarModalAtualizacao}
          cpf={prospecto.cpf}
          buscarProspecto={buscarProspecto}
        />
      )}
      {mostrarModalRemoverResponsavel && (
        <Modal
          show={mostrarModalRemoverResponsavel}
          onHide={fecharModalRemoverResponsavel}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title
              style={{
                fontFamily: 'Open Sans, sans-serif',
                fontWeight: 700,
                color: '#d9534f',
              }}
            >
              <FaTimes className="mr-2 text-danger" />
              Remover {getLabelTipoResponsavel(tipoResponsavelRemocao)}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {tipoResponsavelRemocao === 'imobiliaria' && (
              <div className="alert alert-warning mb-3">
                <strong>Atenção:</strong> Ao remover a Imobiliária, o Corretor
                vinculado também será removido automaticamente.
              </div>
            )}
            <Form.Group>
              <Form.Label>
                Justificativa <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Informe o motivo da remoção..."
                value={justificativaRemocao}
                onChange={e => setJustificativaRemocao(e.target.value)}
                maxLength={500}
              />
              <Form.Text className="text-muted">
                {justificativaRemocao.length}/500 caracteres
              </Form.Text>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={fecharModalRemoverResponsavel}
              disabled={removendoResponsavel}
            >
              Cancelar
            </Button>
            <Button
              variant="danger"
              onClick={confirmarRemocaoResponsavel}
              disabled={removendoResponsavel || !justificativaRemocao.trim()}
            >
              {removendoResponsavel ? 'Removendo...' : 'Confirmar Remoção'}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Container>
  );
}
